var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAmiriyaHeroAr(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 2143 737",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-10,.cls-100,.cls-101,.cls-102,.cls-103,.cls-104,.cls-105,.cls-106,.cls-107,.cls-108,.cls-109,.cls-11,.cls-110,.cls-111,.cls-112,.cls-113,.cls-114,.cls-115,.cls-116,.cls-117,.cls-118,.cls-119,.cls-12,.cls-120,.cls-121,.cls-122,.cls-123,.cls-124,.cls-125,.cls-126,.cls-127,.cls-128,.cls-129,.cls-13,.cls-130,.cls-131,.cls-132,.cls-133,.cls-134,.cls-135,.cls-136,.cls-137,.cls-138,.cls-139,.cls-14,.cls-140,.cls-141,.cls-142,.cls-143,.cls-144,.cls-145,.cls-146,.cls-147,.cls-148,.cls-149,.cls-15,.cls-150,.cls-151,.cls-152,.cls-153,.cls-154,.cls-155,.cls-156,.cls-157,.cls-158,.cls-159,.cls-16,.cls-160,.cls-161,.cls-162,.cls-163,.cls-164,.cls-165,.cls-166,.cls-167,.cls-168,.cls-169,.cls-17,.cls-170,.cls-18,.cls-19,.cls-2,.cls-20,.cls-21,.cls-22,.cls-23,.cls-24,.cls-25,.cls-26,.cls-27,.cls-28,.cls-29,.cls-3,.cls-30,.cls-31,.cls-32,.cls-33,.cls-34,.cls-35,.cls-36,.cls-37,.cls-38,.cls-39,.cls-4,.cls-40,.cls-41,.cls-42,.cls-43,.cls-44,.cls-45,.cls-46,.cls-47,.cls-48,.cls-49,.cls-5,.cls-50,.cls-51,.cls-52,.cls-53,.cls-54,.cls-55,.cls-56,.cls-57,.cls-58,.cls-59,.cls-6,.cls-60,.cls-61,.cls-62,.cls-63,.cls-64,.cls-65,.cls-66,.cls-67,.cls-68,.cls-69,.cls-7,.cls-70,.cls-71,.cls-72,.cls-73,.cls-74,.cls-75,.cls-76,.cls-77,.cls-78,.cls-79,.cls-8,.cls-80,.cls-81,.cls-82,.cls-83,.cls-84,.cls-85,.cls-86,.cls-87,.cls-88,.cls-89,.cls-9,.cls-90,.cls-91,.cls-92,.cls-93,.cls-94,.cls-95,.cls-96,.cls-97,.cls-98,.cls-99{fill:none;}.cls-1,.cls-10,.cls-105,.cls-106,.cls-107,.cls-108,.cls-109,.cls-11,.cls-110,.cls-111,.cls-112,.cls-113,.cls-114,.cls-115,.cls-116,.cls-117,.cls-118,.cls-119,.cls-12,.cls-120,.cls-121,.cls-122,.cls-123,.cls-124,.cls-125,.cls-126,.cls-127,.cls-128,.cls-129,.cls-13,.cls-130,.cls-131,.cls-132,.cls-133,.cls-134,.cls-135,.cls-136,.cls-137,.cls-138,.cls-139,.cls-14,.cls-140,.cls-141,.cls-142,.cls-143,.cls-144,.cls-145,.cls-146,.cls-147,.cls-148,.cls-149,.cls-15,.cls-150,.cls-151,.cls-152,.cls-153,.cls-154,.cls-155,.cls-156,.cls-157,.cls-158,.cls-159,.cls-16,.cls-160,.cls-161,.cls-162,.cls-163,.cls-164,.cls-165,.cls-166,.cls-167,.cls-168,.cls-169,.cls-17,.cls-170,.cls-18,.cls-19,.cls-2,.cls-20,.cls-21,.cls-22,.cls-23,.cls-24,.cls-25,.cls-26,.cls-27,.cls-3,.cls-4,.cls-5,.cls-6,.cls-7,.cls-8,.cls-9{stroke-width:1.5px;}.cls-1{stroke:url(#linear-gradient);}.cls-2{stroke:url(#linear-gradient-2);}.cls-3{stroke:url(#linear-gradient-3);}.cls-4{stroke:url(#linear-gradient-4);}.cls-5{stroke:url(#linear-gradient-5);}.cls-6{stroke:url(#linear-gradient-6);}.cls-7{stroke:url(#linear-gradient-7);}.cls-8{stroke:url(#linear-gradient-8);}.cls-9{stroke:url(#linear-gradient-9);}.cls-10{stroke:url(#linear-gradient-10);}.cls-11{stroke:url(#linear-gradient-11);}.cls-12{stroke:url(#linear-gradient-12);}.cls-13{stroke:url(#linear-gradient-13);}.cls-14{stroke:url(#linear-gradient-14);}.cls-15{stroke:url(#linear-gradient-15);}.cls-16{stroke:url(#linear-gradient-16);}.cls-17{stroke:url(#linear-gradient-17);}.cls-18{stroke:url(#linear-gradient-18);}.cls-19{stroke:url(#linear-gradient-19);}.cls-20{stroke:url(#linear-gradient-20);}.cls-21{stroke:url(#linear-gradient-21);}.cls-22{stroke:url(#linear-gradient-22);}.cls-23{stroke:url(#linear-gradient-23);}.cls-24{stroke:url(#linear-gradient-24);}.cls-25{stroke:url(#linear-gradient-25);}.cls-26{stroke:url(#linear-gradient-26);}.cls-27{stroke:url(#linear-gradient-27);}.cls-100,.cls-101,.cls-102,.cls-103,.cls-104,.cls-28,.cls-29,.cls-30,.cls-31,.cls-32,.cls-33,.cls-34,.cls-35,.cls-36,.cls-37,.cls-38,.cls-39,.cls-40,.cls-41,.cls-42,.cls-43,.cls-44,.cls-45,.cls-46,.cls-47,.cls-48,.cls-49,.cls-50,.cls-51,.cls-52,.cls-53,.cls-54,.cls-55,.cls-56,.cls-57,.cls-58,.cls-59,.cls-60,.cls-61,.cls-62,.cls-63,.cls-64,.cls-65,.cls-66,.cls-67,.cls-68,.cls-69,.cls-70,.cls-71,.cls-72,.cls-73,.cls-74,.cls-75,.cls-76,.cls-77,.cls-78,.cls-79,.cls-80,.cls-81,.cls-82,.cls-83,.cls-84,.cls-85,.cls-86,.cls-87,.cls-88,.cls-89,.cls-90,.cls-91,.cls-92,.cls-93,.cls-94,.cls-95,.cls-96,.cls-97,.cls-98,.cls-99{stroke-miterlimit:10;}.cls-28{stroke:url(#linear-gradient-28);}.cls-29{stroke:url(#linear-gradient-29);}.cls-30{stroke:url(#linear-gradient-30);}.cls-31{stroke:url(#linear-gradient-31);}.cls-32{stroke:url(#linear-gradient-32);}.cls-33{stroke:url(#linear-gradient-33);}.cls-34{stroke:url(#linear-gradient-34);}.cls-35{stroke:url(#linear-gradient-35);}.cls-36{stroke:url(#linear-gradient-36);}.cls-37{stroke:url(#linear-gradient-37);}.cls-38{stroke:url(#linear-gradient-38);}.cls-39{stroke:url(#linear-gradient-39);}.cls-40{stroke:url(#linear-gradient-40);}.cls-41{stroke:url(#linear-gradient-41);}.cls-42{stroke:url(#linear-gradient-42);}.cls-43{stroke:url(#linear-gradient-43);}.cls-44{stroke:url(#linear-gradient-44);}.cls-45{stroke:url(#linear-gradient-45);}.cls-46{stroke:url(#linear-gradient-46);}.cls-47{stroke:url(#linear-gradient-47);}.cls-48{stroke:url(#linear-gradient-48);}.cls-49{stroke:url(#linear-gradient-49);}.cls-50{stroke:url(#linear-gradient-50);}.cls-51{stroke:url(#linear-gradient-51);}.cls-52{stroke:url(#linear-gradient-52);}.cls-53{stroke:url(#linear-gradient-53);}.cls-54{stroke:url(#linear-gradient-54);}.cls-55{stroke:url(#linear-gradient-55);}.cls-56{stroke:url(#linear-gradient-56);}.cls-57{stroke:url(#linear-gradient-57);}.cls-58{stroke:url(#linear-gradient-58);}.cls-59{stroke:url(#linear-gradient-59);}.cls-60{stroke:url(#linear-gradient-60);}.cls-61{stroke:url(#linear-gradient-61);}.cls-62{stroke:url(#linear-gradient-62);}.cls-63{stroke:url(#linear-gradient-63);}.cls-64{stroke:url(#linear-gradient-64);}.cls-65{stroke:url(#linear-gradient-65);}.cls-66{stroke:url(#linear-gradient-66);}.cls-67{stroke:url(#linear-gradient-67);}.cls-68{stroke:url(#linear-gradient-68);}.cls-69{stroke:url(#linear-gradient-69);}.cls-70{stroke:url(#linear-gradient-70);}.cls-71{stroke:url(#linear-gradient-71);}.cls-72{stroke:url(#linear-gradient-72);}.cls-73{stroke:url(#linear-gradient-73);}.cls-74{stroke:url(#linear-gradient-74);}.cls-75{stroke:url(#linear-gradient-75);}.cls-76{stroke:url(#linear-gradient-76);}.cls-77{stroke:url(#linear-gradient-77);}.cls-78{stroke:url(#linear-gradient-78);}.cls-79{stroke:url(#linear-gradient-79);}.cls-80{stroke:url(#linear-gradient-80);}.cls-81{stroke:url(#linear-gradient-81);}.cls-82{stroke:url(#linear-gradient-82);}.cls-83{stroke:url(#linear-gradient-83);}.cls-84{stroke:url(#linear-gradient-84);}.cls-85{stroke:url(#linear-gradient-85);}.cls-86{stroke:url(#linear-gradient-86);}.cls-87{stroke:url(#linear-gradient-87);}.cls-88{stroke:url(#linear-gradient-88);}.cls-89{stroke:url(#linear-gradient-89);}.cls-90{stroke:url(#linear-gradient-90);}.cls-91{stroke:url(#linear-gradient-91);}.cls-92{stroke:url(#linear-gradient-92);}.cls-93{stroke:url(#linear-gradient-93);}.cls-94{stroke:url(#linear-gradient-94);}.cls-95{stroke:url(#linear-gradient-95);}.cls-96{stroke:url(#linear-gradient-96);}.cls-97{stroke:url(#linear-gradient-97);}.cls-98{stroke:url(#linear-gradient-98);}.cls-99{stroke:url(#linear-gradient-99);}.cls-100{stroke:url(#linear-gradient-100);}.cls-101{stroke:url(#linear-gradient-101);}.cls-102{stroke:url(#linear-gradient-102);}.cls-103{stroke:url(#linear-gradient-103);}.cls-104{stroke:url(#linear-gradient-104);}.cls-105{stroke:url(#linear-gradient-105);}.cls-106{stroke:url(#linear-gradient-106);}.cls-107{stroke:url(#linear-gradient-107);}.cls-108{stroke:url(#linear-gradient-108);}.cls-109{stroke:url(#linear-gradient-109);}.cls-110{stroke:url(#linear-gradient-110);}.cls-111{stroke:url(#linear-gradient-111);}.cls-112{stroke:url(#linear-gradient-112);}.cls-113{stroke:url(#linear-gradient-113);}.cls-114{stroke:url(#linear-gradient-114);}.cls-115{stroke:url(#linear-gradient-115);}.cls-116{stroke:url(#linear-gradient-116);}.cls-117{stroke:url(#linear-gradient-117);}.cls-118{stroke:url(#linear-gradient-118);}.cls-119{stroke:url(#linear-gradient-119);}.cls-120{stroke:url(#linear-gradient-120);}.cls-121{stroke:url(#linear-gradient-121);}.cls-122{stroke:url(#linear-gradient-122);}.cls-123{stroke:url(#linear-gradient-123);}.cls-124{stroke:url(#linear-gradient-124);}.cls-125{stroke:url(#linear-gradient-125);}.cls-126{stroke:url(#linear-gradient-126);}.cls-127{stroke:url(#linear-gradient-127);}.cls-128{stroke:url(#linear-gradient-128);}.cls-129{stroke:url(#linear-gradient-129);}.cls-130{stroke:url(#linear-gradient-130);}.cls-131{stroke:url(#linear-gradient-131);}.cls-132{stroke:url(#linear-gradient-132);}.cls-133{stroke:url(#linear-gradient-133);}.cls-134{stroke:url(#linear-gradient-134);}.cls-135{stroke:url(#linear-gradient-135);}.cls-136{stroke:url(#linear-gradient-136);}.cls-137{stroke:url(#linear-gradient-137);}.cls-138{stroke:url(#linear-gradient-138);}.cls-139{stroke:url(#linear-gradient-139);}.cls-140{stroke:url(#linear-gradient-140);}.cls-141{stroke:url(#linear-gradient-141);}.cls-142{stroke:url(#linear-gradient-142);}.cls-143{stroke:url(#linear-gradient-143);}.cls-144{stroke:url(#linear-gradient-144);}.cls-145{stroke:url(#linear-gradient-145);}.cls-146{stroke:url(#linear-gradient-146);}.cls-147{stroke:url(#linear-gradient-147);}.cls-148{stroke:url(#linear-gradient-148);}.cls-149{stroke:url(#linear-gradient-149);}.cls-150{stroke:url(#linear-gradient-150);}.cls-151{stroke:url(#linear-gradient-151);}.cls-152{stroke:url(#linear-gradient-152);}.cls-153{stroke:url(#linear-gradient-153);}.cls-154{stroke:url(#linear-gradient-154);}.cls-155{stroke:url(#linear-gradient-155);}.cls-156{stroke:url(#linear-gradient-156);}.cls-157{stroke:url(#linear-gradient-157);}.cls-158{stroke:url(#linear-gradient-158);}.cls-159{stroke:url(#linear-gradient-159);}.cls-160{stroke:url(#linear-gradient-160);}.cls-161{stroke:url(#linear-gradient-161);}.cls-162{stroke:url(#linear-gradient-162);}.cls-163{stroke:url(#linear-gradient-163);}.cls-164{stroke:url(#linear-gradient-164);}.cls-165{stroke:url(#linear-gradient-165);}.cls-166{stroke:url(#linear-gradient-166);}.cls-167{stroke:url(#linear-gradient-167);}.cls-168{stroke:url(#linear-gradient-168);}.cls-169{stroke:url(#linear-gradient-169);}.cls-170{stroke:url(#linear-gradient-170);}.cls-171{opacity:0.32;}.cls-172{opacity:0.24;isolation:isolate;fill:url(#linear-gradient-171);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 2773.93,
    y1: 706.01,
    x2: 2776.77,
    y2: 708.33,
    gradientTransform: "matrix(173.13, 0, 0, -177.07, -480407.37, 125920.52)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff",
    stopOpacity: 0.64
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 2773.82,
    y1: 706.09,
    x2: 2776.66,
    y2: 708.41,
    gradientTransform: "matrix(172.47, 0, 0, -174.24, -478552.49, 123930.13)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 2773.72,
    y1: 706.16,
    x2: 2776.56,
    y2: 708.48,
    gradientTransform: "matrix(171.86, 0, 0, -171.66, -476836.23, 122112.66)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 2773.64,
    y1: 706.23,
    x2: 2776.48,
    y2: 708.54,
    gradientTransform: "matrix(171.3, 0, 0, -168.38, -475268.68, 119801.76)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 2773.41,
    y1: 706.49,
    x2: 2776.25,
    y2: 708.81,
    gradientTransform: "matrix(170.75, 0, 0, -165.34, -473720.22, 117657.26)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 2773.48,
    y1: 706.38,
    x2: 2776.32,
    y2: 708.69,
    gradientTransform: "matrix(170.11, 0, 0, -162.16, -471929.54, 115418.74)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 2773.39,
    y1: 706.45,
    x2: 2776.24,
    y2: 708.76,
    gradientTransform: "matrix(169.51, 0, 0, -158.86, -470246.12, 113091.09)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 2773.32,
    y1: 706.54,
    x2: 2776.17,
    y2: 708.85,
    gradientTransform: "matrix(168.93, 0, 0, -155.27, -468621.62, 110561.7)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: 2773.04,
    y1: 706.89,
    x2: 2775.88,
    y2: 709.2,
    gradientTransform: "matrix(168.4, 0, 0, -151.71, -467124.71, 108057.64)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: 2773.15,
    y1: 706.76,
    x2: 2775.99,
    y2: 709.07,
    gradientTransform: "matrix(167.89, 0, 0, -148.05, -465698.15, 105479.62)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: 2773.07,
    y1: 706.88,
    x2: 2775.92,
    y2: 709.19,
    gradientTransform: "matrix(167.43, 0, 0, -144.29, -464401.56, 102827.8)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    x1: 2772.98,
    y1: 706.98,
    x2: 2775.82,
    y2: 709.3,
    gradientTransform: "matrix(166.73, 0, 0, -140.44, -462442.24, 100117.63)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-13",
    x1: 2772.9,
    y1: 707.12,
    x2: 2775.75,
    y2: 709.43,
    gradientTransform: "matrix(166.21, 0, 0, -136.52, -460980.93, 97353.39)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-14",
    x1: 2772.84,
    y1: 707.26,
    x2: 2775.68,
    y2: 709.57,
    gradientTransform: "matrix(165.72, 0, 0, -132.52, -459609.99, 94538.86)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-15",
    x1: 2772.76,
    y1: 707.41,
    x2: 2775.61,
    y2: 709.73,
    gradientTransform: "matrix(165.3, 0, 0, -128.47, -458424.46, 91683.85)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-16",
    x1: 2772.71,
    y1: 707.57,
    x2: 2775.56,
    y2: 709.89,
    gradientTransform: "matrix(164.96, 0, 0, -124.38, -457467.4, 88802.77)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-17",
    x1: 2772.69,
    y1: 707.74,
    x2: 2775.53,
    y2: 710.05,
    gradientTransform: "matrix(164.7, 0, 0, -120.24, -456740.42, 85886.33)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-18",
    x1: 2772.68,
    y1: 707.91,
    x2: 2775.52,
    y2: 710.23,
    gradientTransform: "matrix(164.53, 0, 0, -116.07, -456265.73, 82949.28)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-19",
    x1: 2772.64,
    y1: 708.15,
    x2: 2775.48,
    y2: 710.47,
    gradientTransform: "matrix(164.46, 0, 0, -111.88, -456058.9, 80001.68)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-20",
    x1: 2772.66,
    y1: 708.35,
    x2: 2775.51,
    y2: 710.66,
    gradientTransform: "matrix(164.47, 0, 0, -107.69, -456091.27, 77048.29)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-21",
    x1: 2772.68,
    y1: 708.58,
    x2: 2775.52,
    y2: 710.89,
    gradientTransform: "matrix(164.58, 0, 0, -103.5, -456396.09, 74097.76)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-22",
    x1: 2772.57,
    y1: 709.02,
    x2: 2775.42,
    y2: 711.33,
    gradientTransform: "matrix(164.78, 0, 0, -99.32, -456953.45, 71153.63)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-23",
    x1: 2772.76,
    y1: 709.13,
    x2: 2775.6,
    y2: 711.44,
    gradientTransform: "matrix(165.09, 0, 0, -95.17, -457809.69, 68228.68)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-24",
    x1: 2772.82,
    y1: 709.43,
    x2: 2775.66,
    y2: 711.74,
    gradientTransform: "matrix(165.48, 0, 0, -91.04, -458900.4, 65320.88)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-25",
    x1: 2772.76,
    y1: 709.92,
    x2: 2775.6,
    y2: 712.23,
    gradientTransform: "matrix(165.97, 0, 0, -86.95, -460273.8, 62440.3)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-26",
    x1: 2772.86,
    y1: 710.27,
    x2: 2775.7,
    y2: 712.59,
    gradientTransform: "matrix(166.55, 0, 0, -82.92, -461893.43, 59600.73)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-27",
    x1: 2773.11,
    y1: 710.47,
    x2: 2775.95,
    y2: 712.78,
    gradientTransform: "matrix(167.19, 0, 0, -78.91, -463687.29, 56777.63)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-28",
    x1: 69.92,
    y1: 412.49,
    x2: 751.75,
    y2: 412.49,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 738)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#153d5e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#0b2a49"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#a7861f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-29",
    x1: 72.05,
    y1: 412.34,
    x2: 749.69,
    y2: 412.34,
    xlinkHref: "#linear-gradient-28"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-30",
    x1: 74.19,
    y1: 412.62,
    x2: 747.63,
    y2: 412.62,
    xlinkHref: "#linear-gradient-28"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-31",
    x1: 76.32,
    y1: 412.88,
    x2: 745.58,
    y2: 412.88,
    xlinkHref: "#linear-gradient-28"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-32",
    x1: 78.45,
    y1: 412.97,
    x2: 743.42,
    y2: 412.97,
    xlinkHref: "#linear-gradient-28"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-33",
    x1: 80.59,
    y1: 413.03,
    x2: 741.42,
    y2: 413.03,
    xlinkHref: "#linear-gradient-28"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-34",
    x1: 82.02,
    y1: 413.49,
    x2: 739.35,
    y2: 413.49,
    xlinkHref: "#linear-gradient-28"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-35",
    x1: 84.97,
    y1: 413.45,
    x2: 737.2,
    y2: 413.45,
    xlinkHref: "#linear-gradient-28"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-36",
    x1: 86.99,
    y1: 413.72,
    x2: 735.12,
    y2: 413.72,
    xlinkHref: "#linear-gradient-28"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-37",
    x1: 89.26,
    y1: 413.64,
    x2: 733.01,
    y2: 413.64,
    xlinkHref: "#linear-gradient-28"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-38",
    x1: 91.4,
    y1: 413.79,
    x2: 730.94,
    y2: 413.79,
    xlinkHref: "#linear-gradient-28"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-39",
    x1: 93.54,
    y1: 414.1,
    x2: 728.86,
    y2: 414.1,
    xlinkHref: "#linear-gradient-28"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-40",
    x1: 95.69,
    y1: 414.25,
    x2: 726.91,
    y2: 414.25,
    xlinkHref: "#linear-gradient-28"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-41",
    x1: 97.82,
    y1: 414.38,
    x2: 724.68,
    y2: 414.38,
    xlinkHref: "#linear-gradient-28"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-42",
    x1: 99.67,
    y1: 414.48,
    x2: 722.58,
    y2: 414.48,
    xlinkHref: "#linear-gradient-28"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-43",
    x1: 102.11,
    y1: 414.6,
    x2: 720.81,
    y2: 414.6,
    xlinkHref: "#linear-gradient-28"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-44",
    x1: 104.25,
    y1: 414.71,
    x2: 718.74,
    y2: 414.71,
    xlinkHref: "#linear-gradient-28"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-45",
    x1: 106.4,
    y1: 414.86,
    x2: 716.6,
    y2: 414.86,
    xlinkHref: "#linear-gradient-28"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-46",
    x1: 108.53,
    y1: 414.99,
    x2: 714.45,
    y2: 414.99,
    xlinkHref: "#linear-gradient-28"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-47",
    x1: 110.67,
    y1: 415.12,
    x2: 712.46,
    y2: 415.12,
    xlinkHref: "#linear-gradient-28"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-48",
    x1: 112.53,
    y1: 414.95,
    x2: 710.44,
    y2: 414.95,
    xlinkHref: "#linear-gradient-28"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-49",
    x1: 111.96,
    y1: 414.57,
    x2: 708.4,
    y2: 414.57,
    xlinkHref: "#linear-gradient-28"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-50",
    x1: 116.74,
    y1: 415.27,
    x2: 706.25,
    y2: 415.27,
    xlinkHref: "#linear-gradient-28"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-51",
    x1: 118.94,
    y1: 415.4,
    x2: 704.19,
    y2: 415.4,
    xlinkHref: "#linear-gradient-28"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-52",
    x1: 121.07,
    y1: 415.54,
    x2: 702.13,
    y2: 415.54,
    xlinkHref: "#linear-gradient-28"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-53",
    x1: 123.18,
    y1: 415.58,
    x2: 700.1,
    y2: 415.58,
    xlinkHref: "#linear-gradient-28"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-54",
    x1: 125.34,
    y1: 414.36,
    x2: 698,
    y2: 414.36,
    xlinkHref: "#linear-gradient-28"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-55",
    x1: 127.45,
    y1: 414.26,
    x2: 695.93,
    y2: 414.26,
    xlinkHref: "#linear-gradient-28"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-56",
    x1: 129.54,
    y1: 413.63,
    x2: 693.8,
    y2: 413.63,
    xlinkHref: "#linear-gradient-28"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-57",
    x1: 131.72,
    y1: 412.97,
    x2: 691.8,
    y2: 412.97,
    xlinkHref: "#linear-gradient-28"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-58",
    x1: 133.88,
    y1: 411.55,
    x2: 689.74,
    y2: 411.55,
    xlinkHref: "#linear-gradient-28"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-59",
    x1: 136.03,
    y1: 411.35,
    x2: 687.68,
    y2: 411.35,
    xlinkHref: "#linear-gradient-28"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-60",
    x1: 138.14,
    y1: 411.01,
    x2: 685.6,
    y2: 411.01,
    xlinkHref: "#linear-gradient-28"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-61",
    x1: 140.2,
    y1: 410.36,
    x2: 683.5,
    y2: 410.36,
    xlinkHref: "#linear-gradient-28"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-62",
    x1: 142.29,
    y1: 409.7,
    x2: 681.53,
    y2: 409.7,
    xlinkHref: "#linear-gradient-28"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-63",
    x1: 144.51,
    y1: 409.09,
    x2: 679.42,
    y2: 409.09,
    xlinkHref: "#linear-gradient-28"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-64",
    x1: 146.63,
    y1: 408.37,
    x2: 677.36,
    y2: 408.37,
    xlinkHref: "#linear-gradient-28"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-65",
    x1: 148.76,
    y1: 407.73,
    x2: 675.2,
    y2: 407.73,
    xlinkHref: "#linear-gradient-28"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-66",
    x1: 150.83,
    y1: 407.07,
    x2: 673.2,
    y2: 407.07,
    xlinkHref: "#linear-gradient-28"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-67",
    x1: 153.06,
    y1: 406.42,
    x2: 671.19,
    y2: 406.42,
    xlinkHref: "#linear-gradient-28"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-68",
    x1: 155.15,
    y1: 405.57,
    x2: 669.06,
    y2: 405.57,
    xlinkHref: "#linear-gradient-28"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-69",
    x1: 157.27,
    y1: 405.09,
    x2: 667.08,
    y2: 405.09,
    xlinkHref: "#linear-gradient-28"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-70",
    x1: 159.44,
    y1: 404.45,
    x2: 665,
    y2: 404.45,
    xlinkHref: "#linear-gradient-28"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-71",
    x1: 161.59,
    y1: 403.76,
    x2: 662.87,
    y2: 403.76,
    xlinkHref: "#linear-gradient-28"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-72",
    x1: 163.65,
    y1: 402.29,
    x2: 660.86,
    y2: 402.29,
    xlinkHref: "#linear-gradient-28"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-73",
    x1: 165.81,
    y1: 402.47,
    x2: 658.81,
    y2: 402.47,
    xlinkHref: "#linear-gradient-28"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-74",
    x1: 167.88,
    y1: 401.78,
    x2: 656.7,
    y2: 401.78,
    xlinkHref: "#linear-gradient-28"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-75",
    x1: 170.05,
    y1: 401.18,
    x2: 654.68,
    y2: 401.18,
    xlinkHref: "#linear-gradient-28"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-76",
    x1: 172.14,
    y1: 399.72,
    x2: 652.59,
    y2: 399.72,
    xlinkHref: "#linear-gradient-28"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-77",
    x1: 174.25,
    y1: 399.86,
    x2: 650.57,
    y2: 399.86,
    xlinkHref: "#linear-gradient-28"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-78",
    x1: 176.4,
    y1: 398.39,
    x2: 648.47,
    y2: 398.39,
    xlinkHref: "#linear-gradient-28"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-79",
    x1: 178.5,
    y1: 397.72,
    x2: 646.42,
    y2: 397.72,
    xlinkHref: "#linear-gradient-28"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-80",
    x1: 180.61,
    y1: 397.82,
    x2: 644.33,
    y2: 397.82,
    xlinkHref: "#linear-gradient-28"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-81",
    x1: 182.76,
    y1: 397.14,
    x2: 642.27,
    y2: 397.14,
    xlinkHref: "#linear-gradient-28"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-82",
    x1: 184.88,
    y1: 396.52,
    x2: 640.22,
    y2: 396.52,
    xlinkHref: "#linear-gradient-28"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-83",
    x1: 187.02,
    y1: 395.89,
    x2: 638.18,
    y2: 395.89,
    xlinkHref: "#linear-gradient-28"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-84",
    x1: 189.14,
    y1: 394.94,
    x2: 636.15,
    y2: 394.94,
    xlinkHref: "#linear-gradient-28"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-85",
    x1: 191.25,
    y1: 394.17,
    x2: 634.05,
    y2: 394.17,
    xlinkHref: "#linear-gradient-28"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-86",
    x1: 192.36,
    y1: 393.08,
    x2: 631.99,
    y2: 393.08,
    xlinkHref: "#linear-gradient-28"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-87",
    x1: 195.5,
    y1: 393.27,
    x2: 629.86,
    y2: 393.27,
    xlinkHref: "#linear-gradient-28"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-88",
    x1: 196.67,
    y1: 392.31,
    x2: 627.82,
    y2: 392.31,
    xlinkHref: "#linear-gradient-28"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-89",
    x1: 199.7,
    y1: 391.84,
    x2: 625.78,
    y2: 391.84,
    xlinkHref: "#linear-gradient-28"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-90",
    x1: 201.86,
    y1: 391.17,
    x2: 623.74,
    y2: 391.17,
    xlinkHref: "#linear-gradient-28"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-91",
    x1: 203.31,
    y1: 390.62,
    x2: 621.69,
    y2: 390.62,
    xlinkHref: "#linear-gradient-28"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-92",
    x1: 206.03,
    y1: 389.97,
    x2: 619.61,
    y2: 389.97,
    xlinkHref: "#linear-gradient-28"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-93",
    x1: 208.18,
    y1: 389.39,
    x2: 617.51,
    y2: 389.39,
    xlinkHref: "#linear-gradient-28"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-94",
    x1: 210.27,
    y1: 387.64,
    x2: 615.4,
    y2: 387.64,
    xlinkHref: "#linear-gradient-28"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-95",
    x1: 212.42,
    y1: 387.81,
    x2: 613.42,
    y2: 387.81,
    xlinkHref: "#linear-gradient-28"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-96",
    x1: 214.61,
    y1: 387.15,
    x2: 611.49,
    y2: 387.15,
    xlinkHref: "#linear-gradient-28"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-97",
    x1: 216.58,
    y1: 386.56,
    x2: 609.28,
    y2: 386.56,
    xlinkHref: "#linear-gradient-28"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-98",
    x1: 218.75,
    y1: 386.01,
    x2: 607.34,
    y2: 386.01,
    xlinkHref: "#linear-gradient-28"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-99",
    x1: 220.84,
    y1: 385.19,
    x2: 605.23,
    y2: 385.19,
    xlinkHref: "#linear-gradient-28"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-100",
    x1: 222.96,
    y1: 384.18,
    x2: 603.21,
    y2: 384.18,
    xlinkHref: "#linear-gradient-28"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-101",
    x1: 225.05,
    y1: 383.91,
    x2: 601.01,
    y2: 383.91,
    xlinkHref: "#linear-gradient-28"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-102",
    x1: 227.16,
    y1: 383.1,
    x2: 599.1,
    y2: 383.1,
    xlinkHref: "#linear-gradient-28"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-103",
    x1: 229.24,
    y1: 382.39,
    x2: 597.05,
    y2: 382.39,
    xlinkHref: "#linear-gradient-28"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-104",
    x1: 232.66,
    y1: 381.94,
    x2: 593.66,
    y2: 381.94,
    xlinkHref: "#linear-gradient-28"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-105",
    x1: 2761.07,
    y1: 707.79,
    x2: 2762.75,
    y2: 709.01,
    gradientTransform: "matrix(109.47, 0, 0, -142.58, -302405.96, 101356.12)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff",
    stopOpacity: 0.16
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-106",
    x1: 2760.83,
    y1: 708.16,
    x2: 2762.51,
    y2: 709.37,
    gradientTransform: "matrix(109.5, 0, 0, -141.42, -302483.34, 100542.76)",
    xlinkHref: "#linear-gradient-105"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-107",
    x1: 2761.04,
    y1: 707.94,
    x2: 2762.73,
    y2: 709.16,
    gradientTransform: "matrix(109.6, 0, 0, -140.29, -302760.02, 99744.96)",
    xlinkHref: "#linear-gradient-105"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-108",
    x1: 2761.16,
    y1: 707.91,
    x2: 2762.85,
    y2: 709.13,
    gradientTransform: "matrix(109.77, 0, 0, -139.16, -303241.24, 98950.04)",
    xlinkHref: "#linear-gradient-105"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-109",
    x1: 2761.19,
    y1: 707.98,
    x2: 2762.88,
    y2: 709.19,
    gradientTransform: "matrix(109.92, 0, 0, -138.05, -303654.31, 98169.43)",
    xlinkHref: "#linear-gradient-105"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-110",
    x1: 2761.29,
    y1: 708.01,
    x2: 2762.98,
    y2: 709.23,
    gradientTransform: "matrix(110.22, 0, 0, -137, -304495.69, 97433.7)",
    xlinkHref: "#linear-gradient-105"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-111",
    x1: 2761.39,
    y1: 708.07,
    x2: 2763.08,
    y2: 709.29,
    gradientTransform: "matrix(110.59, 0, 0, -136.24, -305529.06, 96900.23)",
    xlinkHref: "#linear-gradient-105"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-112",
    x1: 2761.55,
    y1: 708.09,
    x2: 2763.23,
    y2: 709.3,
    gradientTransform: "matrix(111.03, 0, 0, -135.45, -306758.04, 96344.11)",
    xlinkHref: "#linear-gradient-105"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-113",
    x1: 2761.73,
    y1: 708.09,
    x2: 2763.42,
    y2: 709.31,
    gradientTransform: "matrix(111.52, 0, 0, -134.62, -308134.27, 95759.85)",
    xlinkHref: "#linear-gradient-105"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-114",
    x1: 2761.91,
    y1: 708.13,
    x2: 2763.6,
    y2: 709.35,
    gradientTransform: "matrix(112.08, 0, 0, -133.74, -309699.38, 95139.54)",
    xlinkHref: "#linear-gradient-105"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-115",
    x1: 2762.1,
    y1: 708.19,
    x2: 2763.78,
    y2: 709.4,
    gradientTransform: "matrix(112.7, 0, 0, -132.8, -311431.67, 94480.27)",
    xlinkHref: "#linear-gradient-105"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-116",
    x1: 2762.33,
    y1: 708.21,
    x2: 2764.01,
    y2: 709.43,
    gradientTransform: "matrix(113.38, 0, 0, -131.81, -313332.84, 93781.28)",
    xlinkHref: "#linear-gradient-105"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-117",
    x1: 2762.53,
    y1: 708.3,
    x2: 2764.21,
    y2: 709.51,
    gradientTransform: "matrix(114.11, 0, 0, -130.9, -315376.03, 93144.78)",
    xlinkHref: "#linear-gradient-105"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-118",
    x1: 2762.8,
    y1: 708.3,
    x2: 2764.49,
    y2: 709.52,
    gradientTransform: "matrix(114.9, 0, 0, -129.71, -317587.07, 92304.45)",
    xlinkHref: "#linear-gradient-105"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-119",
    x1: 2763.07,
    y1: 708.35,
    x2: 2764.75,
    y2: 709.57,
    gradientTransform: "matrix(115.74, 0, 0, -128.47, -319936.49, 91431.4)",
    xlinkHref: "#linear-gradient-105"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-120",
    x1: 2763.33,
    y1: 708.42,
    x2: 2765.01,
    y2: 709.64,
    gradientTransform: "matrix(116.63, 0, 0, -127.18, -322425.89, 90525.36)",
    xlinkHref: "#linear-gradient-105"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-121",
    x1: 2763.55,
    y1: 708.49,
    x2: 2765.24,
    y2: 709.71,
    gradientTransform: "matrix(117.44, 0, 0, -125.86, -324690.06, 89598.67)",
    xlinkHref: "#linear-gradient-105"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-122",
    x1: 2763.89,
    y1: 708.5,
    x2: 2765.58,
    y2: 709.72,
    gradientTransform: "matrix(118.46, 0, 0, -124.53, -327553.42, 88659.03)",
    xlinkHref: "#linear-gradient-105"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-123",
    x1: 2764.2,
    y1: 708.56,
    x2: 2765.89,
    y2: 709.78,
    gradientTransform: "matrix(119.53, 0, 0, -123.18, -330547.93, 87709.55)",
    xlinkHref: "#linear-gradient-105"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-124",
    x1: 2764.49,
    y1: 708.66,
    x2: 2766.18,
    y2: 709.87,
    gradientTransform: "matrix(120.65, 0, 0, -121.81, -333679.14, 86748.53)",
    xlinkHref: "#linear-gradient-105"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-125",
    x1: 2764.83,
    y1: 708.7,
    x2: 2766.52,
    y2: 709.91,
    gradientTransform: "matrix(121.8, 0, 0, -120.44, -336898.18, 85780.53)",
    xlinkHref: "#linear-gradient-105"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-126",
    x1: 2765.16,
    y1: 708.76,
    x2: 2766.84,
    y2: 709.98,
    gradientTransform: "matrix(122.98, 0, 0, -119.03, -340204.73, 84791.46)",
    xlinkHref: "#linear-gradient-105"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-127",
    x1: 2765.47,
    y1: 708.87,
    x2: 2767.16,
    y2: 710.08,
    gradientTransform: "matrix(124.21, 0, 0, -117.6, -343640.05, 83785.14)",
    xlinkHref: "#linear-gradient-105"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-128",
    x1: 2765.79,
    y1: 708.94,
    x2: 2767.48,
    y2: 710.16,
    gradientTransform: "matrix(125.46, 0, 0, -116.13, -347138.05, 82750.55)",
    xlinkHref: "#linear-gradient-105"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-129",
    x1: 2766.15,
    y1: 709,
    x2: 2767.83,
    y2: 710.21,
    gradientTransform: "matrix(126.74, 0, 0, -114.62, -350721.76, 81684.87)",
    xlinkHref: "#linear-gradient-105"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-130",
    x1: 2766.46,
    y1: 709.08,
    x2: 2768.15,
    y2: 710.3,
    gradientTransform: "matrix(128.04, 0, 0, -113.05, -354365.79, 80584.15)",
    xlinkHref: "#linear-gradient-105"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-131",
    x1: 2766.82,
    y1: 709.14,
    x2: 2768.5,
    y2: 710.36,
    gradientTransform: "matrix(129.37, 0, 0, -111.43, -358091.24, 79442.17)",
    xlinkHref: "#linear-gradient-105"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-132",
    x1: 2767.02,
    y1: 709.42,
    x2: 2768.71,
    y2: 710.64,
    gradientTransform: "matrix(130.73, 0, 0, -109.73, -361891.99, 78246.85)",
    xlinkHref: "#linear-gradient-105"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-133",
    x1: 2767.47,
    y1: 709.33,
    x2: 2769.15,
    y2: 710.54,
    gradientTransform: "matrix(132.1, 0, 0, -108.37, -365732.2, 77289.53)",
    xlinkHref: "#linear-gradient-105"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-134",
    x1: 2767.78,
    y1: 709.41,
    x2: 2769.47,
    y2: 710.62,
    gradientTransform: "matrix(133.5, 0, 0, -107.2, -369647.38, 76466.54)",
    xlinkHref: "#linear-gradient-105"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-135",
    x1: 2768.13,
    y1: 709.44,
    x2: 2769.81,
    y2: 710.65,
    gradientTransform: "matrix(134.91, 0, 0, -106.02, -373598.13, 75632.8)",
    xlinkHref: "#linear-gradient-105"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-136",
    x1: 2768.43,
    y1: 709.53,
    x2: 2770.12,
    y2: 710.74,
    gradientTransform: "matrix(136.35, 0, 0, -104.89, -377624.14, 74838.72)",
    xlinkHref: "#linear-gradient-105"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-137",
    x1: 2768.77,
    y1: 709.57,
    x2: 2770.45,
    y2: 710.79,
    gradientTransform: "matrix(137.8, 0, 0, -103.85, -381681.27, 74103.98)",
    xlinkHref: "#linear-gradient-105"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-138",
    x1: 2768.88,
    y1: 709.9,
    x2: 2770.57,
    y2: 711.12,
    gradientTransform: "matrix(139.26, 0, 0, -102.91, -385769.44, 73442.56)",
    xlinkHref: "#linear-gradient-105"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-139",
    x1: 2769.38,
    y1: 709.7,
    x2: 2771.06,
    y2: 710.92,
    gradientTransform: "matrix(140.74, 0, 0, -102.09, -389910.41, 72869.5)",
    xlinkHref: "#linear-gradient-105"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-140",
    x1: 2769.7,
    y1: 709.72,
    x2: 2771.39,
    y2: 710.94,
    gradientTransform: "matrix(142.23, 0, 0, -101.44, -394085.55, 72410.93)",
    xlinkHref: "#linear-gradient-105"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-141",
    x1: 2770,
    y1: 709.76,
    x2: 2771.69,
    y2: 710.97,
    gradientTransform: "matrix(143.74, 0, 0, -100.97, -398308.97, 72079.24)",
    xlinkHref: "#linear-gradient-105"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-142",
    x1: 2770.34,
    y1: 709.74,
    x2: 2772.02,
    y2: 710.95,
    gradientTransform: "matrix(145.25, 0, 0, -100.66, -402543.66, 71860.13)",
    xlinkHref: "#linear-gradient-105"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-143",
    x1: 2770.61,
    y1: 709.77,
    x2: 2772.29,
    y2: 710.99,
    gradientTransform: "matrix(146.79, 0, 0, -100.5, -406846.76, 71749.39)",
    xlinkHref: "#linear-gradient-105"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-144",
    x1: 2770.92,
    y1: 709.75,
    x2: 2772.61,
    y2: 710.97,
    gradientTransform: "matrix(148.32, 0, 0, -100.48, -411138.13, 71736.05)",
    xlinkHref: "#linear-gradient-105"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-145",
    x1: 2771.22,
    y1: 709.73,
    x2: 2772.91,
    y2: 710.95,
    gradientTransform: "matrix(149.87, 0, 0, -100.6, -415473.79, 71817.22)",
    xlinkHref: "#linear-gradient-105"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-146",
    x1: 2771.51,
    y1: 709.71,
    x2: 2773.2,
    y2: 710.93,
    gradientTransform: "matrix(151.43, 0, 0, -100.82, -419843.06, 71973.25)",
    xlinkHref: "#linear-gradient-105"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-147",
    x1: 2771.78,
    y1: 709.69,
    x2: 2773.47,
    y2: 710.9,
    gradientTransform: "matrix(153, 0, 0, -101.17, -424232.66, 72218.58)",
    xlinkHref: "#linear-gradient-105"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-148",
    x1: 2772.07,
    y1: 709.66,
    x2: 2773.76,
    y2: 710.88,
    gradientTransform: "matrix(154.57, 0, 0, -101.63, -428627.81, 72542.7)",
    xlinkHref: "#linear-gradient-105"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-149",
    x1: 2772.37,
    y1: 709.59,
    x2: 2774.05,
    y2: 710.81,
    gradientTransform: "matrix(156.14, 0, 0, -102.19, -433029.74, 72937.08)",
    xlinkHref: "#linear-gradient-105"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-150",
    x1: 2772.62,
    y1: 709.57,
    x2: 2774.31,
    y2: 710.79,
    gradientTransform: "matrix(157.72, 0, 0, -102.83, -437450.21, 73389.37)",
    xlinkHref: "#linear-gradient-105"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-151",
    x1: 2772.89,
    y1: 709.5,
    x2: 2774.57,
    y2: 710.72,
    gradientTransform: "matrix(159.3, 0, 0, -103.54, -441875.21, 73888.3)",
    xlinkHref: "#linear-gradient-105"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-152",
    x1: 2773.13,
    y1: 709.47,
    x2: 2774.82,
    y2: 710.68,
    gradientTransform: "matrix(160.79, 0, 0, -104.29, -446045.73, 74418.02)",
    xlinkHref: "#linear-gradient-105"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-153",
    x1: 2773.37,
    y1: 709.42,
    x2: 2775.06,
    y2: 710.63,
    gradientTransform: "matrix(162.33, 0, 0, -105.09, -450352.94, 74980.94)",
    xlinkHref: "#linear-gradient-105"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-154",
    x1: 2773.58,
    y1: 709.4,
    x2: 2775.27,
    y2: 710.62,
    gradientTransform: "matrix(163.86, 0, 0, -105.95, -454636.57, 75585.84)",
    xlinkHref: "#linear-gradient-105"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-155",
    x1: 2773.86,
    y1: 709.3,
    x2: 2775.54,
    y2: 710.52,
    gradientTransform: "matrix(165.39, 0, 0, -106.83, -458914.4, 76202.96)",
    xlinkHref: "#linear-gradient-105"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-156",
    x1: 2774.1,
    y1: 709.23,
    x2: 2775.79,
    y2: 710.44,
    gradientTransform: "matrix(166.9, 0, 0, -107.74, -463150.02, 76842.97)",
    xlinkHref: "#linear-gradient-105"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-157",
    x1: 2774.26,
    y1: 709.29,
    x2: 2775.94,
    y2: 710.5,
    gradientTransform: "matrix(168.43, 0, 0, -108.64, -467424, 77479.31)",
    xlinkHref: "#linear-gradient-105"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-158",
    x1: 2774.49,
    y1: 709.21,
    x2: 2776.17,
    y2: 710.43,
    gradientTransform: "matrix(169.94, 0, 0, -109.55, -471658.57, 78121.42)",
    xlinkHref: "#linear-gradient-105"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-159",
    x1: 2774.75,
    y1: 709.08,
    x2: 2776.43,
    y2: 710.3,
    gradientTransform: "matrix(171.46, 0, 0, -110.45, -475908.58, 78751.67)",
    xlinkHref: "#linear-gradient-105"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-160",
    x1: 2774.98,
    y1: 709.04,
    x2: 2776.66,
    y2: 710.25,
    gradientTransform: "matrix(172.96, 0, 0, -111.32, -480109.02, 79363.97)",
    xlinkHref: "#linear-gradient-105"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-161",
    x1: 2775.11,
    y1: 709.1,
    x2: 2776.79,
    y2: 710.32,
    gradientTransform: "matrix(174.48, 0, 0, -112.14, -484359.93, 79944)",
    xlinkHref: "#linear-gradient-105"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-162",
    x1: 2775.38,
    y1: 708.97,
    x2: 2777.06,
    y2: 710.18,
    gradientTransform: "matrix(175.99, 0, 0, -112.94, -488593.16, 80507.64)",
    xlinkHref: "#linear-gradient-105"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-163",
    x1: 2775.57,
    y1: 708.93,
    x2: 2777.26,
    y2: 710.15,
    gradientTransform: "matrix(177.52, 0, 0, -113.72, -492870.17, 81053.76)",
    xlinkHref: "#linear-gradient-105"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-164",
    x1: 2775.78,
    y1: 708.89,
    x2: 2777.47,
    y2: 710.1,
    gradientTransform: "matrix(179.06, 0, 0, -114.47, -497181.4, 81581.65)",
    xlinkHref: "#linear-gradient-105"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-165",
    x1: 2775.96,
    y1: 708.85,
    x2: 2777.65,
    y2: 710.06,
    gradientTransform: "matrix(180.44, 0, 0, -115.16, -501047.51, 82068.89)",
    xlinkHref: "#linear-gradient-105"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-166",
    x1: 2776.17,
    y1: 708.77,
    x2: 2777.85,
    y2: 709.99,
    gradientTransform: "matrix(181.99, 0, 0, -116.19, -505385.41, 82791.48)",
    xlinkHref: "#linear-gradient-105"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-167",
    x1: 2776.31,
    y1: 708.85,
    x2: 2777.99,
    y2: 710.07,
    gradientTransform: "matrix(183.61, 0, 0, -116.65, -509919.26, 83115.46)",
    xlinkHref: "#linear-gradient-105"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-168",
    x1: 2776.47,
    y1: 708.87,
    x2: 2778.16,
    y2: 710.09,
    gradientTransform: "matrix(185.25, 0, 0, -117.07, -514506.81, 83412.03)",
    xlinkHref: "#linear-gradient-105"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-169",
    x1: 2776.76,
    y1: 708.76,
    x2: 2778.45,
    y2: 709.97,
    gradientTransform: "matrix(186.97, 0, 0, -117.45, -519322.33, 83682.11)",
    xlinkHref: "#linear-gradient-105"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-170",
    x1: 2776.96,
    y1: 709.05,
    x2: 2778.65,
    y2: 710.26,
    gradientTransform: "matrix(188.56, 0, 0, -111.08, -523778.71, 79195.17)",
    xlinkHref: "#linear-gradient-105"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-171",
    x1: 2794.62,
    y1: 706.89,
    x2: 2794.62,
    y2: 705.89,
    gradientTransform: "matrix(420, 0, 0, -340, -1172449, 240124)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3b82f6",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#3b82f6",
    stopOpacity: 0.71
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#dbeafe"
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "amiriyaHeroArArtboard 1") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M297.88,449.86c6.24,2,13.08,5.88,20.22,11.32A187.89,187.89,0,0,1,340,481.57c7.27,7.75,14.33,16.05,20.61,23.81s11.78,15,16.11,21c10.46,14.63,14.09,22.13,8.67,26.68-3,2.52-7.81,4.7-14.27,7s-14.55,4.77-23.52,8.5a109.12,109.12,0,0,0-18,9.46,113.59,113.59,0,0,0-16.08,13c-6.49,6.23-12.42,13.16-18.63,19.24s-12.74,11.22-20.72,13.45c-6.18,1.73-12.71,2-19.77-3.56S241,606.07,235.47,597a179.88,179.88,0,0,1-14.7-29.86c-3.61-9.53-5.78-18.2-6-26.56A73.37,73.37,0,0,1,221,509.55a138.66,138.66,0,0,1,18.83-31c8-10.19,17.53-19.77,27.25-25.54S286.76,446.35,297.88,449.86Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M301.46,451.75c6.28,2.27,13.15,6.45,20.31,12.11a208,208,0,0,1,21.94,20.76c7.27,7.77,14.3,16,20.54,23.55s11.7,14.54,16,20.35c10.24,13.85,13.82,20.7,8.46,25-3,2.36-7.77,4.4-14.25,6.57s-14.66,4.44-23.78,7.89a113.12,113.12,0,0,0-18.49,8.9,106.62,106.62,0,0,0-16.46,12.44c-6.64,6-12.64,12.85-18.8,18.94s-12.54,11.37-20.22,13.88c-5.94,2-12.3,1-18.93-2.65S244.57,607,239.09,598.17a166.3,166.3,0,0,1-14.57-29.86c-3.55-9.68-5.67-18.64-5.8-27.31a78.5,78.5,0,0,1,6.38-32.2,134.63,134.63,0,0,1,18.76-31.34c8-10.11,17.35-19.38,26.86-24.56S290.31,447.7,301.46,451.75Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M305.06,453.81c6.31,2.56,13.21,7,20.39,12.83a234.63,234.63,0,0,1,22,21c7.21,7.82,14.21,15.82,20.44,23.26S379.5,525,383.75,530.51c10,13.07,13.58,19.31,8.29,23.31-3,2.23-7.71,4.16-14.21,6.19s-14.75,4.15-24,7.35a116.38,116.38,0,0,0-19,8.34A102.56,102.56,0,0,0,318,587.56c-6.8,5.84-12.89,12.51-19,18.58s-12.37,11.48-19.77,14.23c-5.73,2.14-11.81,1.5-18.14-1.79S248.17,607.64,242.73,599a152.76,152.76,0,0,1-14.43-29.75c-3.5-9.81-5.57-19-5.66-28a83.66,83.66,0,0,1,6.49-33.3,132.37,132.37,0,0,1,18.67-31.53c7.9-10,17.15-18.92,26.46-23.48S293.87,449.27,305.06,453.81Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M308.66,456c6.32,2.75,13.3,7.46,20.48,13.47a262.37,262.37,0,0,1,22,21.22c7.25,7.7,14.22,15.63,20.39,22.81s11.54,13.59,15.74,18.84c9.85,12.29,13.38,17.93,8.17,21.72-2.9,2.09-7.62,3.94-14.14,5.85s-14.83,3.92-24.26,6.9a123.09,123.09,0,0,0-19.43,7.78,100.9,100.9,0,0,0-17.28,11.26c-7,5.63-13.18,12.16-19.31,18.19s-12.25,11.53-19.39,14.5c-5.53,2.31-11.35,2-17.4-1s-12.47-9.41-17.86-17.76a141,141,0,0,1-14.31-29.53c-3.46-9.93-5.47-19.41-5.52-28.65a88,88,0,0,1,2.92-23.29,104.71,104.71,0,0,1,8.69-21.93,133.13,133.13,0,0,1,13.51-20.84c7.81-9.85,16.69-18.82,26.08-22S297.66,451.21,308.66,456Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M312.29,458.46c6.33,2.94,13.3,7.85,20.55,14.05a304.91,304.91,0,0,1,22,21.29c7.23,7.63,14.17,15.39,20.31,22.33s11.46,13.06,15.63,18c9.67,11.49,13.17,16.47,8,20-2.91,2-7.46,4-13.91,5.86s-14.91,3.64-24.49,6.39a135.53,135.53,0,0,0-19.92,7.26,100.08,100.08,0,0,0-17.8,10.63C315.49,589.68,309.16,596,303,602s-12.17,11.54-19.08,14.71c-5.35,2.46-10.92,2.41-16.71-.23s-12-8-17.3-16a129.2,129.2,0,0,1-14.18-29.25c-3.41-10-5.38-19.69-5.39-29.2a93.92,93.92,0,0,1,3-24,107,107,0,0,1,8.69-22.36,128.13,128.13,0,0,1,13.46-20.8c7.73-9.68,16.38-17.75,25.78-20.35s19.76-1.24,31,3.94Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M315.92,461c6.37,3.14,13.36,8.23,20.61,14.52s14.76,13.74,22,21.27,14.13,15.09,20.23,21.78,11.39,12.49,15.53,17.15c9.5,10.69,12.73,14.79,7.71,18.43-2.81,2-7.24,4.1-13.6,6s-14.92,3.31-24.65,5.85a149.34,149.34,0,0,0-20.42,6.76,99.26,99.26,0,0,0-18.19,10.06c-7.37,5.16-13.84,11.32-20,17.23S293,611.51,286.32,614.86a18.35,18.35,0,0,1-16.08.47C264.7,613,258.91,608.71,253.6,601a117.19,117.19,0,0,1-14.07-28.84,93,93,0,0,1-5.27-29.69,100.3,100.3,0,0,1,3.07-24.75A109.87,109.87,0,0,1,246,495a122.3,122.3,0,0,1,13.35-20.71c7.63-9.49,16.13-16.56,25.54-18.65S304.66,455.46,315.92,461Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M319.57,463.6c8.52,4.44,18.17,12.32,28,21.58s19.73,19.73,28.47,29,16.27,17.14,21.76,22.94c9.34,9.89,12.28,13.32,7.45,17.08-2.71,2.11-7,4.23-13.26,6.11s-14.87,2.9-24.75,5.25a167.25,167.25,0,0,0-20.92,6.29,101.17,101.17,0,0,0-18.69,9.45c-7.59,4.92-14.22,10.87-20.45,16.69s-12.12,11.43-18.63,14.93a17.81,17.81,0,0,1-15.49,1.14c-5.3-2-10.77-6.54-15.92-12.81-5.74-7-10.63-18.19-14-28.25A94.37,94.37,0,0,1,238,542.89a105.33,105.33,0,0,1,3.14-25.42,111.13,111.13,0,0,1,8.67-23.1A115.94,115.94,0,0,1,263,473.81c7.52-9.27,15.94-15.28,25.37-16.87s19.88.82,31.14,6.68Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M323.21,466.36c8.56,4.65,18.23,12.67,28,21.88s19.7,19.48,28.4,28.38q10.72,11,21.65,21.75c9.2,9.1,11.81,12.06,7.19,16-2.6,2.18-6.76,4.38-12.89,6.27s-14.33,3.36-24.64,4.92a123.39,123.39,0,0,0-21.58,5.54,103.33,103.33,0,0,0-19.2,8.84,134.57,134.57,0,0,0-20.93,16.11c-6.3,5.71-12.15,11.32-18.5,14.94-9.84,5.62-20.32,1.81-30.18-10.12-5.51-6.66-10.45-17-13.74-27a95.22,95.22,0,0,1-5-30.45,110.49,110.49,0,0,1,11.87-49.54,108.5,108.5,0,0,1,13.07-20.42c7.41-9,15.81-13.93,25.27-15s19.93,1.75,31.21,7.9Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M326.86,469.19c8.59,4.85,18.29,13,28.09,22.1s19.71,19.17,28.34,27.68q10.59,10.5,21.55,20.49c9.07,8.32,11.31,11,6.92,15.06-2.48,2.26-6.49,4.54-12.5,6.46s-14.11,3.35-24.43,4.69a134.11,134.11,0,0,0-22.26,4.69,108.28,108.28,0,0,0-19.74,8.23,121.5,121.5,0,0,0-21.45,15.49C305,599.66,299.15,605.24,293,609c-9.63,5.78-19.61,2.7-29-8.63-5.28-6.34-10.17-15.82-13.42-25.81a95.63,95.63,0,0,1-4.93-30.71,117.18,117.18,0,0,1,3.25-26.63,114.08,114.08,0,0,1,8.62-23.67,103.6,103.6,0,0,1,12.91-20.14c7.29-8.73,15.77-12.52,25.24-13.19s20,2.63,31.29,9Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M330.52,472.1c8.61,5,18.32,13.18,28.12,22.2s19.63,18.74,28.27,26.88,16,14.64,21.46,19.2c9,7.54,10.81,10.23,6.65,14.4-2.35,2.35-6.21,4.71-12.09,6.66s-13.87,3.36-24.19,4.53c-7.64.84-15.67,1.77-22.9,3.78a113.67,113.67,0,0,0-20.28,7.63,112.3,112.3,0,0,0-22,14.83c-6.49,5.43-12.33,11-18.41,14.78-9.44,5.89-19,3.5-28-7.21-5.07-6-9.82-14.67-13-24.59a95.86,95.86,0,0,1-4.83-30.88,122.8,122.8,0,0,1,3.29-27.15,115.73,115.73,0,0,1,8.59-23.9c3.63-7.42,7.91-14.87,12.75-19.64,7.3-7.18,15.77-11.28,25.26-11.53S319.19,465.52,330.52,472.1Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M334.17,475.07c8.64,5.13,18.37,13.33,28.16,22.2s19.59,18.26,28.19,26,16,13.71,21.4,17.85c8.87,6.78,10.27,9.66,6.37,14-2.22,2.45-5.92,4.9-11.66,6.89S393,565.4,382.7,566.38c-7.68.74-16,1-23.47,2.86a124.41,124.41,0,0,0-20.86,7,107.46,107.46,0,0,0-22.64,14.15c-6.62,5.27-12.48,10.75-18.46,14.6-9.29,6-18.39,4.25-27-5.84a68.61,68.61,0,0,1-12.61-23.37,95.65,95.65,0,0,1-4.75-31,129.25,129.25,0,0,1,3.33-27.63,116.29,116.29,0,0,1,8.54-24.07c3.6-7.39,7.84-14,12.67-18.57,7.27-6.86,15.75-10.54,25.26-10.39s20.1,4.18,31.44,10.92Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M337.83,478.08c8.66,5.23,18.4,13.41,28.18,22.1s19.54,17.71,28.12,25,16.54,13.58,21.27,16.36c7.66,4.51,9.8,9.45,6.15,13.92-2.08,2.55-5.61,5.1-11.21,7.13S397,566,386.71,566.86c-7.71.63-15.87,1.1-23.92,2s-14.92,3.63-21.52,6.3A102.74,102.74,0,0,0,318,588.59c-6.76,5.09-12.67,10.49-18.57,14.38-9.17,6-17.87,4.93-26.13-4.54-4.66-5.35-9-13.09-12-22.29a93.81,93.81,0,0,1-4.65-30.84,132.71,132.71,0,0,1,3.36-28,116,116,0,0,1,8.47-24.19,56,56,0,0,1,12.63-17.45c7.25-6.54,15.74-9.81,25.28-9.29S326.47,471.22,337.83,478.08Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M341.48,481.12c8.69,5.29,18.44,13.43,28.2,21.89s19.5,17.1,28,23.91a211.22,211.22,0,0,0,21,14.63c7.35,4.55,9.58,9.68,6.19,14.32-1.93,2.64-5.29,5.29-10.74,7.37s-13.06,3.5-23.31,4.21c-7.73.53-16,.85-24.13,1.53a86.89,86.89,0,0,0-22.36,5.25,100.82,100.82,0,0,0-24,12.68c-6.92,4.9-12.88,10.19-18.73,14.1-9.07,6.09-17.43,5.54-25.32-3.32-4.47-5-8.6-12.43-11.55-21.41a93.17,93.17,0,0,1-4.49-30.43,138.61,138.61,0,0,1,3.37-28.4,101.71,101.71,0,0,1,8.42-24A56.35,56.35,0,0,1,284.66,477,33.07,33.07,0,0,1,310,468.71c9.56.86,20.22,5.5,31.58,12.43Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M345.13,484.17c8.71,5.34,18.46,13.38,28.21,21.58s19.46,16.41,28,22.75,16,10.2,20.46,13.11c7.07,4.6,9.41,9.91,6.3,14.72-1.78,2.75-5,5.49-10.27,7.63s-12.77,3.58-23,4.18c-7.74.45-16,.63-24.32,1.09a93.14,93.14,0,0,0-23.17,4.15,99.85,99.85,0,0,0-24.76,11.9c-7.09,4.69-13.13,9.86-18.94,13.77-9,6.08-17,6.09-24.6-2.16-4.29-4.69-8.24-11.78-11.06-20.51a93,93,0,0,1-4.28-30,142.14,142.14,0,0,1,3.39-28.69,93,93,0,0,1,8.42-23.31,52.39,52.39,0,0,1,12.6-16,32.42,32.42,0,0,1,25.35-7.23c9.59,1.18,20.27,6.06,31.65,13Z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M348.78,487.22c8.73,5.35,18.48,13.26,28.22,21.17s19.41,15.67,27.91,21.49,15.63,8.84,20,11.8c6.83,4.67,9.29,10.16,6.45,15.16-3.25,5.71-12.12,11-32.36,12.07-7.75.39-16.08.44-24.46.69s-16.76,1-24,3A100.91,100.91,0,0,0,325,583.69c-7.28,4.48-13.42,9.51-19.2,13.41-9,6-16.74,6.56-24-1.09-4.12-4.34-7.89-11.12-10.58-19.59a91.48,91.48,0,0,1-4-29.45,142,142,0,0,1,3.43-28.6,91.25,91.25,0,0,1,8.41-22.93A49.15,49.15,0,0,1,291.66,480c7.25-5.63,15.79-7.75,25.41-6.28S337.39,480.26,348.78,487.22Z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M352.42,490.27c8.74,5.31,18.5,13.05,28.22,20.64S400,525.77,408.5,531.06s15.2,7.68,19.46,10.73c6.62,4.74,9.2,10.42,6.65,15.58-2.93,5.92-11.39,11.51-31.48,12.38-7.73.34-16.09.28-24.57.34s-17.28,0-24.69,1.86a102.06,102.06,0,0,0-26.38,10.29c-7.49,4.25-13.74,9.12-19.53,13-9,6-16.48,7-23.42-.08-4-4-7.57-10.47-10.13-18.66a89.82,89.82,0,0,1-3.75-28.82,142.5,142.5,0,0,1,3.51-28.37,87.67,87.67,0,0,1,8.41-22.6,45.79,45.79,0,0,1,12.59-15c7.25-5.33,15.83-7.11,25.47-5.38s20.39,7,31.78,13.95Z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M356.06,493.28c8.76,5.26,18.52,12.81,28.22,20s19.32,14,27.8,18.73,14.72,6.75,18.91,9.89c6.44,4.82,9.15,10.67,6.89,16-2.61,6.15-10.67,12-30.57,12.73-7.72.29-16.1.13-24.65,0s-17.74-.91-25.37.7A106.51,106.51,0,0,0,330,580.78c-7.71,4-14.1,8.7-19.9,12.5-9,5.9-16.31,7.32-23,.85-3.81-3.71-7.26-9.81-9.69-17.72A87.54,87.54,0,0,1,274,548.26c.51-15.06,3-28.9,7.25-40s10.14-19.68,17.4-24.71,15.87-6.48,25.55-4.5,20.45,7.4,31.84,14.24Z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M359.66,496.26c8.78,5.18,18.53,12.49,28.22,19.32s19.27,13,27.75,17.23,14.18,6.06,18.32,9.29c6.28,4.9,9.14,10.93,7.17,16.44-2.27,6.37-9.94,12.41-29.64,13.09-7.69.26-16.09,0-24.69-.24s-17.42-.54-25.8-.13c-11.53.55-20.42,4.5-28.36,8.25s-14.48,8.26-20.32,12c-9.07,5.79-16.18,7.61-22.58,1.7-3.67-3.39-7-9.14-9.27-16.76A84.41,84.41,0,0,1,277.28,549c.6-14.87,3.14-28.56,7.39-39.52s10.18-19.22,17.46-24,15.93-5.88,25.63-3.69,20.51,7.72,31.9,14.43Z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M363.32,499.19c8.79,5.06,18.53,12.1,28.2,18.51s19.81,12.93,27.71,15.62,13.61,5.64,17.7,9c6.16,5,9.17,11.19,7.49,16.87-1.94,6.59-9.22,12.86-28.69,13.49-7.67.24-16.06-.07-24.71-.46s-17.56-.88-26.09-.77c-11.8.14-21.37,3.37-29.56,6.85s-14.9,7.8-20.79,11.44c-9.16,5.65-16.12,7.82-22.28,2.47-3.56-3.09-6.7-8.5-8.88-15.82a81.31,81.31,0,0,1-2.89-26.66c.7-14.64,3.29-28.17,7.57-38.92s10.23-18.74,17.53-23.2,16-5.29,25.73-2.92,20.56,8,32,14.53Z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M366.94,502.06c8.81,4.91,18.53,11.65,28.19,17.6s19.75,11,27.41,13.73,13.25,5.69,17.32,9.12c6.06,5.1,9.22,11.45,7.84,17.31-1.61,6.8-8.5,13.28-27.74,13.89-7.62.24-16-.12-24.7-.64s-17.67-1.19-26.34-1.35a81.56,81.56,0,0,0-30.75,5.41A136,136,0,0,0,316.86,588c-9.27,5.5-16.12,8-22.07,3.16-3.44-2.78-6.45-7.86-8.51-14.87a78,78,0,0,1-2.62-25.8c.81-14.4,3.45-27.73,7.77-38.25s10.29-18.25,17.63-22.42,16.07-4.74,25.84-2.21S355.54,495.7,366.94,502.06Z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M370.55,504.84c8.82,4.74,18.54,11.14,28.17,16.6a175.5,175.5,0,0,0,27,12c7.44,2.68,12.93,5.75,17,9.28,6,5.2,9.29,11.7,8.2,17.73-1.26,7-7.79,13.72-26.77,14.33A241.46,241.46,0,0,1,399.5,574c-8.72-.63-17.77-1.46-26.56-1.88A89,89,0,0,0,341,576.05a123.26,123.26,0,0,0-21.87,10.21c-9.42,5.31-16.19,8.08-22,3.77-3.34-2.5-6.22-7.24-8.16-13.93a73.92,73.92,0,0,1-2.29-25c.92-14.12,3.62-27.23,8-37.51s10.38-17.74,17.76-21.64,16.14-4.21,26-1.54,20.67,8.3,32.06,14.42Z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M374.15,507.54c8.84,4.53,18.54,10.55,28.16,15.49s19.38,7.84,26.61,10.53,12.65,5.82,16.73,9.47c5.92,5.31,9.39,12,8.6,18.15-.93,7.24-7.09,14.13-25.8,14.77a219.34,219.34,0,0,1-24.59-.88c-8.73-.71-17.84-1.69-26.74-2.34-12.44-.91-24-.24-33.08,2.4a116.81,116.81,0,0,0-22.48,9.55c-9.58,5.1-16.31,8.11-21.9,4.3-3.26-2.22-6-6.63-7.84-13a70.18,70.18,0,0,1-2-24.15c1-13.81,3.83-26.69,8.25-36.71s10.48-17.21,17.9-20.85,16.23-3.7,26.07-.93,20.73,8.37,32.11,14.21Z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M377.75,510.14c8.84,4.3,18.53,9.9,28.13,14.29S425,530.94,432,533.65s12.41,5.91,16.5,9.67c5.89,5.41,9.51,12.21,9,18.55-.58,7.42-6.4,14.53-24.82,15.23a194.59,194.59,0,0,1-24.5-1c-8.74-.78-17.89-1.9-26.88-2.75-12.62-1.2-24.85-1.48-34.19.87A112,112,0,0,0,324,583.12c-9.77,4.87-16.5,8.09-22,4.75-3.18-2-5.83-6-7.55-12.09a66,66,0,0,1-1.69-23.26c1.17-13.47,4-26.12,8.51-35.87s10.61-16.66,18.08-20,16.32-3.22,26.2-.37,20.78,8.38,32.16,13.91Z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M381.33,512.62c8.86,4,18.53,9.19,28.12,13s18.7,5.39,25.6,8.12a50.25,50.25,0,0,1,16.31,9.9c5.86,5.5,9.65,12.45,9.44,19-.25,7.63-5.72,14.9-23.86,15.69a180.44,180.44,0,0,1-24.38-1c-8.73-.85-17.91-2.08-27-3.11-12.78-1.47-25.6-2.72-35.26-.67a109.79,109.79,0,0,0-23.84,8.12c-10,4.62-16.73,8-22.06,5.12-3.12-1.7-5.67-5.45-7.29-11.2s-2.29-13.48-1.4-22.35c1.31-13.13,4.24-25.49,8.81-35s10.73-16.1,18.26-19.24,16.42-2.77,26.32.13,20.84,8.31,32.21,13.49Z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M384.91,515c8.87,3.74,18.51,8.41,28.09,11.61s18.25,4.51,25,7.26A50.73,50.73,0,0,1,454.19,544c5.86,5.62,9.81,12.67,9.88,19.32.09,7.84-5.06,15.28-22.89,16.17a163.71,163.71,0,0,1-24.25-1c-8.71-.89-17.91-2.22-27-3.43-12.93-1.71-26.28-3.94-36.27-2.2a110.49,110.49,0,0,0-24.58,7.37c-10.23,4.35-17.06,7.86-22.27,5.4-6.13-2.9-10.12-14.59-8.17-31.75,1.45-12.77,4.48-24.83,9.13-34s10.89-15.51,18.42-18.39,16.53-2.36,26.47.57,20.88,8.19,32.25,13Z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M388.47,517.21c8.88,3.4,18.5,7.56,28.07,10.12s17.74,3.85,24.37,6.64A51.11,51.11,0,0,1,457,544.33c5.87,5.72,10,12.88,10.33,19.68.42,8-4.44,15.63-21.94,16.63a150.47,150.47,0,0,1-24.1-.91c-8.68-.92-17.89-2.32-27.07-3.68-13-1.94-26-3.71-37.19-3.7s-18.65,4-25.38,6.56c-10.49,4.06-17.4,7.68-22.55,5.61-6.08-2.45-9.82-13.41-7.69-30,1.6-12.4,4.74-24.14,9.47-33s11-15,18.66-17.65,16.64-2,26.62,1,20.93,8,32.28,12.38Z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M449.66,581.82c-8.7.58-18.77-.12-29.52-1.49s-22.17-3.41-33.23-5.09-22.4-4-31-2.79a112.76,112.76,0,0,0-21.52,5.21c-11.76,4.1-19.1,8-24.26,5.14s-8-12.88-5.91-27.61c1.75-12,5-23.41,9.82-32s11.19-14.38,18.89-16.85,16.76-1.61,26.77,1.29,21,7.77,32.32,11.66c8.88,3,18.49,6.65,28,8.54s17.17,3.45,23.7,6.28a51.83,51.83,0,0,1,16.09,10.61c6.44,6.36,11,14.47,10.85,21.92s-5.21,14.14-21.06,15.19Z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M484.07,20.46,316.53,191.92l-101.16-52h0L70.66,426.09h0L203,455.56,336.5,630.77h0l235.76-38.83h0L751,286.7h0L614.66,245.18,484.08,20.46Zm0,.06L614.6,245.2h0L751,286.72,572.26,591.94,336.53,630.76,203,455.55h0L70.72,426.09,215.37,140l101.16,52h0Z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M72.86,425.3l131.46,29.24h0L337.53,627.72,570.8,590.46l97.1-166.13,81-137.08L613.41,246h0l-46.54-79.3L483.13,23.3,317,193.12h0l-100.22-51ZM337.52,627.77h0L204.3,454.58,72.79,425.33h0L216.71,142.07h0l100.22,51L483.14,23.23h0L566.88,166.6l46.53,79.3,135.53,41.31h0l-81,137.11L570.83,590.46h0l-233.3,37.27Z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M75,424.51l130.62,29h0L338.54,624.67,569.33,589l96.45-165.32,81-135.89L612.17,246.68h0l-46.51-78.44L482.2,26.09,317.4,194.28h0l-99.29-50ZM338.53,624.75h0L205.6,453.58l-130.67-29h0L218.07,144.24h0l99.29,50L482.21,26h0l83.51,142.19,46.51,78.45,134.64,41.09h0l-81,135.92L569.4,589h0L338.57,624.7Z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M77.15,423.72l129.77,28.81h0L339.56,621.66l228.32-34.14L663.66,423l81.05-134.7L611,247.46h0l-46.49-77.61-83.25-141L317.84,195.46h0l-98.35-49Zm262.39,198h0L206.89,452.58,77.06,423.76h0L219.42,146.33h0l98.36,49L481.29,28.77h0l83.27,141,46.5,77.69,133.76,40.87h0L663.75,423.06,567.93,587.6h0L339.57,621.75Z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M79.29,422.93l128.94,28.6h0l132.34,167.1,225.85-32.58,95.15-163.7,81.09-133.51L609.84,248.21h0l-46.49-76.75-83-139.78L318.27,196.59h0l-97.42-48.07ZM340.55,618.7h0L208.19,451.58,79.19,423h0L220.8,148.46h0l97.43,48.07,162.1-165h0l83,139.82,46.46,76.76,132.87,40.64h0l-81,133.63-95.2,163.73h0L340.57,618.69Z"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M81.43,422.14l128.1,28.38h0l132,165.07,223.38-31,94.5-162.89,81.11-132.32L608.66,249h0L562.22,173,479.41,34.46,318.66,197.74h0l-96.48-47.08ZM341.55,615.68h0L209.49,450.58,81.33,422.19h0L222.16,150.56h0l96.5,47.1L479.43,34.31h0L562.23,173l46.43,76,132,40.42h0L659.53,421.72,565,584.65h0l-223.43,31Z"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "M83.57,421.35l127.26,28.17h0l131.76,163,220.9-29.47L657.34,421l81.13-131.12-131-40.18h0l-46.42-75.08L478.48,37.21,319.13,198.9h0l-95.55-46.1-140,268.56Zm259,191.3h0l-131.76-163L83.46,421.46h0l140-268.67h0L319,198.89,478.5,37.08v.05l82.56,137.45,46.42,75.07,131.1,40.2h0L657.42,421.06,563.54,583.18h0l-221,29.47Z"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "M85.72,420.56l126.41,27.95h0l131.47,161L562,581.61l93.2-161.28L736.4,290.46l-130.14-40h0l-46.4-74.24L477.56,40l-158,160.06h0L225,154.94ZM343.57,609.63h0l-131.48-161-126.49-28v0L224.87,154.84h0L319.5,200l158-160.09h0l82.32,136.27,46.39,74.23,130.22,40h0l-81.18,130L562,581.66h0l-218.5,27.91Z"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M87.86,419.78l125.57,27.73h0l131.18,159,216-26.34L653.16,419.7,734.35,291,605.1,251.22h0l-46.44-73.41-82-135L320,201.21h0l-93.68-44.13ZM344.58,606.61h0l-131.18-159L87.74,419.86h0L226.24,157h0l93.69,44.13L476.66,42.62v.05l82.1,135.09,46.37,73.38L734.46,290.9V291l-81.22,128.8-92.58,160.5h0l-216,26.35Z"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M90,419l124.72,27.47h0l130.93,157,213.49-24.78L651.05,419l81.19-127.56L603.88,252h0l-46.37-72.49L475.66,45.56,320.43,202.37h0l-92.77-43.16ZM345.59,603.58h0l-130.93-157L89.86,419.06V419l137.8-259.92h0l92.76,43.15L475.72,45.38h0l81.85,133.9,46.34,72.54,128.48,39.64v.06L651.15,419.13l-91.93,159.7h0L345.66,603.62Z"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    className: "cls-38",
    d: "M92.15,418.2,216,445.46h0l130.63,155,211-23.22,91.26-158.85L730.16,292l-127.5-39.3h0L556.33,181,474.77,48.34,320.86,203.52h0l-91.81-42.15ZM346.6,600.56h0L216,445.56,92,418.24v-.06l137-257h0l91.82,42.16,154-155.22h0l81.62,132.72,46.32,71.69,127.56,39.32v0L649,418.46l-91.28,158.9h0Z"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M94.29,417.46l123,27.08h0L347.66,597.46,556.2,575.8l90.61-158,81.27-125.18L601.5,253.46h0l-46.31-70.87L473.83,51.12,321.29,204.68h0l-90.91-41.22ZM347.66,597.54h0l-130.39-153L94.12,417.46v-.07L230.29,163.31h0l90.89,41.15L473.86,50.94V51l81.38,131.53,46.3,70.85,126.71,39.08v.06L646.94,417.76l-90.68,158.1h0Z"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    className: "cls-40",
    d: "M96.44,416.62l122.22,26.84h0l130,150.89,206.07-20.1,90-157.24L726,293,600.35,254.18h0l-46.29-70L473,53.89,321.73,205.83h0l-89.94-40.19ZM348.66,594.51h0l-130-150.9L96.26,416.7v-.07l135.4-251.17h0l90,40.2,151.23-152v.06L554,184.07l46.27,70,125.8,38.87-.05.07L644.71,417l-90,157.29h0Z"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M98.58,415.83l121.36,26.63h0l129.72,148.9,203.6-18.54,89.3-156.43L723.89,293.6,599.1,255h0l-46.26-69.18L472,56.7,322.16,207h0l-89-39.21ZM349.66,591.46h0L219.87,442.59,98.39,415.92v-.08L233.06,167.6h0l89,39.22L472,56.46v.07l80.91,129.16,46.25,69.16,124.9,38.61v.07l-81.4,122.93L553.32,572.94h0Z"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "M100.72,415l120.52,26.42h0L350.66,588.33l201.12-17,88.66-155.61,81.35-121.61L597.9,255.72h0l-46.24-68.34L471.05,59.46,322.59,208.14h0l-88.07-38.22ZM350.66,588.46h0L221.17,441.59,100.52,415.13l0-.07L234.42,169.73h0L322.51,208,471.07,59.25v.07l80.67,128L598,255.63l124,38.43v.08L640.57,415.82,551.9,571.46h0Z"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    className: "cls-43",
    d: "M102.87,414.25l119.67,26.21h0L351.66,585.3l198.66-15.43,88-154.8,81.34-120.43-123-38.18h0L550.45,189,470.12,62.24,323,209.3h0l-87.14-37.24ZM351.66,585.46h0L222.46,440.6l-119.8-26.25v-.08L235.78,171.86h.06L323,209.1,470.14,62v.07l80.52,126.8,46.21,67.47L720,294.57l0,.07-81.43,120.5L550.52,570h0Z"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    className: "cls-44",
    d: "M105,413.46l118.83,26h0L352.66,582.25l196.18-13.87,87.36-154,81.46-119.21L595.55,257.23h0l-46.19-66.64L469.19,65,323.45,210.46h0l-86.2-36.25Zm247.65,169h0L223.76,439.6l-119-26v-.09L237.06,174h.06l86.22,36.26L469.14,64.79v.08l80.32,125.59,46.2,66.65,122.25,38-.06.08L636.38,414.46,549,568.52h0Z"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    className: "cls-45",
    d: "M107.16,412.68l118,25.78h0L353.73,579.22l193.71-12.31,86.7-153.19,81.44-118L594.36,258h0l-46.17-65.8L468.26,67.8,323.89,211.61h0l-85.23-35.27Zm246.5,166.71h0L225.06,438.6,106.92,412.78v-.09L238.46,176.12h.06l85.33,35.34L468.29,67.56v.08l80,124.43,46.15,65.78,121.37,37.76-.06.09L634.26,413.82,547.52,567.08h0Z"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    className: "cls-46",
    d: "M109.3,411.89l117.14,25.57h0L354.72,576.2,546,565.46l86-152.38,81.46-116.85-120.32-37.5h0l-46.14-65L467.33,70.58l-143,142.18h-.05l-84.35-34.3ZM354.66,576.37h0L226.36,437.6,109.06,412v-.1l130.8-233.65h.07l84.35,34.3L467.36,70.33v.13L547.09,193.7l46.13,64.94,120.44,37.5-.06.09L632.08,413.17,546,565.61h0Z"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M111.44,411.1l116.3,25.36h0l128,136.7L544.51,564l85.41-151.52,81.49-115.67L592,259.46h0l-46.12-64.11-79.44-122L324.75,213.92h0l-83.4-33.31ZM355.66,573.34h0l-128-136.74L111.19,411.21v-.09l130-230.73h.06l83.41,33.31L466.42,73.1v.09l79.49,122.07L592,259.34l119.64,37.32-.07.1L630.06,412.51l-85.4,151.64h0Z"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    className: "cls-48",
    d: "M113.59,410.31,229,435.46h0l127.7,134.68L543,562.52l84.75-150.76,81.52-114.48-118.54-37h0l-46.11-63.34L465.46,76.15,325.18,215.07h0l-82.52-32.34Zm243.1,160h0L229,435.6,113.32,410.46l.06-.1L242.59,182.55h.07l82.48,32.33,140.36-139,.06.08,79.25,120.89,46.08,63.24,118.71,37.1-.07.09L628,411.85l-84.8,150.84h0l-186.5,7.63Z"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    className: "cls-49",
    d: "M115.73,409.52l114.61,24.94h0L357.75,567.11,541.57,561,625.66,411.1,707.2,297.81,589.56,261h0l-46.08-62.42L464.48,79,325.66,216.23h-.06l-81.53-31.34L115.77,409.54Zm242,157.77h0L230.25,434.6l-114.8-25,.06-.1L244,184.61H244L325.57,216l139-137.37.06.09,79,119.78,46.06,62.39,117.83,36.88-.08.1L625.86,411.21l-84.15,150h0l-184,6.07Z"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    className: "cls-50",
    d: "M117.87,408.73l113.79,24.73h0L358.79,564.09l181.35-4.51,83.45-149.12,81.57-112.09-116.75-36.6h0l-46.06-61.58L463.66,81.71,326.05,217.38H326L245.39,187ZM358.71,564.27h0L231.55,433.6l-114-24.74.07-.11,127.66-222h.08L326,217.12,463.66,81.46l.06.09,78.79,118.51,46,61.56,116.94,36.66-.07.1L623.74,410.57,540.24,559.8h-.06Z"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "M120,407.94,233,432.46h0l126.83,128.6,178.88-3,82.8-148.33,81.6-110.91L587.22,262.46h0l-46-60.73L462.66,84.46,326.46,218.51h-.06l-79.66-29.37ZM359.71,561.25h0L232.85,432.61,119.72,408.08l.07-.12L246.66,189h.08l79.68,29.37L462.71,84.19l.07.09,78.54,117.34,46,60.7,116.06,36.44-.08.11-81.67,111L538.78,558.28h0Z"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    className: "cls-52",
    d: "M122.16,407.15l112.09,24.31h0L360.79,558l176.41-1.39,82.15-147.52L701,299.46,586,263.31h0l-46-59.9-78.25-116L326.91,219.69l-78.79-28.4-126,215.86ZM360.73,558.22h0L234.15,431.61l-112.3-24.32.07-.12L248,191h.08l78.75,28.42L461.78,87l.07.1,78.31,116.15,46,59.86,115.18,36.21-.08.12-81.7,109.82L537.35,556.83h-.06Z"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    className: "cls-53",
    d: "M361.82,555l173.94.17,81.5-146.7,81.65-108.53L584.84,264h0l-46-59-78-114.87L327.36,220.93h-.06l-77.81-27.47L124.31,406.36l111.24,24.1h0Zm174.06.38h-.06l-174.09-.17h0L235.45,430.61,124,406.51l.08-.13L249.4,193.17h.08l77.81,27.41L460.86,89.73l.07.1,78.07,115,46,59,114.29,36-.08.11L617.44,408.56Z"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    className: "cls-54",
    d: "M362.83,552l171.47,1.73,80.85-145.9,81.68-107.33L583.66,264.74h0l-46-58.21L459.89,92.83,327.78,222l-76.93-26.44-124.4,210,110.4,23.9h0L362.85,552Zm171.59,1.94h-.06l-171.62-1.73h0l-126-122.53L126.12,405.75l.07-.12,124.57-210.3h.08l76.88,26.43L459.93,92.46l.07.11,77.84,113.78,45.93,58.17,113.41,35.77-.09.12L615.33,407.86Z"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    className: "cls-55",
    d: "M363.84,548.93l169,3.29L613,407.12,694.75,301,582.46,265.46h0L536.52,208.1,459,95.6,328.21,223.16h-.06l-75.93-25.44L128.6,404.79l109.55,23.67h0L363.82,549ZM533,552.46h-.07l-169.15-3.29h0L238,428.61,128.25,404.94l.08-.13L252.12,197.46h.08l76,25.45L459,95.27l.08.11L536.68,208l45.91,57.33,112.52,35.55L695,301,613.23,407.24Z"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    className: "cls-56",
    d: "M364.85,545.9l166.53,4.84,79.55-144.28,81.73-105L581.27,266.21h0l-45.92-56.52L458,98.39,328.66,224.31h-.06l-75-24.45L130.74,404l108.71,23.4h0L364.83,545.88ZM531.51,551h-.07l-166.68-4.84h0L239.34,427.61l-109-23.46.08-.13,123-204.46h.09l75,24.46L458,98l.08.11,77.36,111.42L581.33,266,693,301.36l-.1.13L611.05,406.57,531.44,551Z"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    className: "cls-57",
    d: "M365.86,542.87l164.06,6.4,78.9-143.47L690.58,302l-110.5-35h0l-45.89-55.67-77-110.13-128,124.3h-.07l-74.06-23.48L132.88,403.21,240.75,426.4h0Zm164.19,6.64H530L365.77,543.1h0L240.66,426.61,132.53,403.37l.09-.14L254.86,201.7H255L329,225.18,457.14,100.81l.08.12,77.13,110.23,45.86,55.64L691,301.91l-.1.13L609,405.93,530,549.51Z"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    className: "cls-58",
    d: "M366.88,539.84l161.58,8,78.25-142.66,81.78-102.59-109.6-34.8h0L533,213,456.18,104,329.51,226.62h-.07l-73.13-22.49L135,402.46l107,23h0L366.84,539.88Zm161.72,8.21h-.08l-161.74-8h0L241.93,425.61l-107.28-23,.08-.14L256.2,203.86h.09l73.15,22.49L456.21,103.59l.09.11,76.89,109.05L579,267.54,688.9,302.46l-.11.14L606.91,405.3,528.6,548.08Z"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    className: "cls-59",
    d: "M367.89,536.81,527,546.33l77.6-141.87,81.81-101.4-108.75-34.6h0l-45.84-54L455.24,106.71l-125.31,121h-.07l-72.2-21.46L137.16,401.63l106.18,22.76h0l124.52,112.4Zm159.25,9.78h-.08l-159.27-9.53h0L243.27,424.66,136.82,401.84l.09-.15L257.56,206h.09l72.22,21.5,125.41-121.1.09.12L532,214.34l45.82,54,109,34.67-.11.14L604.82,404.61l-77.67,142Z"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    className: "cls-60",
    d: "M368.9,533.78l156.64,11.08,77-141,81.84-100.2L576.51,269.3h0l-45.85-53.22L454.32,109.52l-124,119.41h-.07L259,208.46,139.32,400.84l105.34,22.54h0Zm156.76,11.34h-.08L368.78,534h0L244.53,423.62,138.91,401l.09-.16L258.93,208.09H259l71.28,20.53L454.36,109.13l.08.12,76.42,106.68L576.65,269l108.11,34.43-.12.15L602.66,404l-77,141.16Z"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    className: "cls-61",
    d: "M369.91,530.75l154.17,12.63,76.3-140.23,81.86-99L575.32,270h0l-45.8-52.3-76.1-105.38L330.81,230.09h-.08L260.4,210.55,141.46,400.06,246,422.38h0L369.89,530.73Zm154.32,12.91h-.09L369.81,531h0l-124-108.39L141,400.23l.1-.15L260.27,210.22h.09l70.35,19.54,122.7-117.89.09.12,76.16,105.53,45.77,52.26L682.66,304l-.12.15-82,99.15L524.23,543.66Z"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    className: "cls-62",
    d: "M370.92,527.72l151.74,14.19,75.61-139.45,81.89-97.83-106-33.9h0l-45.77-51.45-75.87-104.2L331.24,231.24h-.07l-69.4-18.56L143.66,399.27l103.64,22.1h0ZM522.77,542.2h-.11L370.79,528h0L247.13,421.62l-104-22.17.11-.16L261.66,212.35h.1l69.41,18.56L452.51,114.64l.09.12,76,104.32,45.74,51.38,106.32,34-.13.15-82,98L522.81,542.17Z"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    className: "cls-63",
    d: "M371.93,524.69l149.23,15.77,75-138.61,81.91-96.64L572.94,271.53h0l-45.76-50.61-75.63-103L331.66,232.4l-68.53-17.6L145.75,398.46l102.8,21.89h0Zm149.38,16h-.09l-149.4-15.76h0L248.43,420.62l-103.12-22,.1-.16,117.6-184h.1L331.59,232l120-114.65.09.13,75.71,103.13,45.73,50.57L678.57,305l-.13.16-82,96.77L521.36,540.68Z"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    className: "cls-64",
    d: "M373,521.66,519.66,539,594,401.17,676,305.72l-104.2-33.46h0L526,222.46,450.6,120.63,332.1,233.54H332L264.5,217,147.89,397.69l102,21.67h0Zm146.91,17.61h-.1L372.83,521.94h0L249.73,419.62,147.44,397.88l.11-.17L264.37,216.62h.1L332,233.22l118.62-113,.1.13,75.47,102,45.7,49.72,104.57,33.57-.14.16-82.06,95.59L519.86,539.27Z"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    className: "cls-65",
    d: "M374,518.63l144.28,18.83,73.7-137,82-94.27L570.56,273h0l-45.71-48.93L449.66,123.46,332.54,234.7h-.08l-66.6-15.61L150,396.9l101.11,21.46h0ZM518.4,537.81h-.1L373.84,518.93h0L251,418.62,149.57,397.09l.11-.17,116-178.17h.1l66.62,15.62L449.66,123l.1.13L525,223.86l45.66,48.88,103.69,33.34-.14.17-82.09,94.4L518.34,537.79Z"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    className: "cls-66",
    d: "M375,515.6,516.78,536l73.05-136.18,82-93.07-102.45-33h0l-45.72-48.11L448.75,126.2,333,235.86l-65.74-14.64-115,174.89,100.26,21.24h0L375,515.58Zm142,20.75h-.1l-142-20.45h0l-122.5-98.24L151.66,396.31l.12-.18L267.05,220.88h.11l65.68,14.64,115.9-109.78.1.13,75,99.58,45.65,48L672.3,306.57l-.15.16L590,400,516.9,536.28Z"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    className: "cls-67",
    d: "M376,512.57l139.34,22,72.4-135.37,82-91.88L568.16,274.54h0L522.5,227.3,447.82,129,333.41,237h-.08L268.6,223.38l-114.26,172,99.42,21h0L376,512.58Zm139.51,22.31h-.11l-139.52-22h0l-122.2-96.25-99.79-21.1.12-.19L268.49,223h.11l64.75,13.66L447.89,128.51l.1.13L522.76,227l45.63,47.19,101.92,32.9-.15.17L588,399.3,515.53,534.83Z"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    className: "cls-68",
    d: "M377,509.54l136.87,23.54,71.8-134.56,82-90.7L567,275.27h0l-45.65-46.39-74.43-97.09-113,106.41h-.08L270,225.46l-113.48,169,98.57,20.8h0L377,509.46Zm137,23.88h-.11l-137-23.57h0L255,415.67l-99-20.89.12-.19,113.73-169.4h.1l63.82,12.66L446.92,131.32l.1.14,74.53,97.21L567.15,275l101,32.68-.16.17-82.18,90.85L514,533.46Z"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    className: "cls-69",
    d: "M378,506.51,512.4,531.6l71.12-133.77,82.05-89.48L565.8,276h0l-45.64-45.56L446,134.56,334.27,239.32h-.08l-62.87-11.68L158.66,393.75l97.73,20.58h0L378,506.46ZM512.57,532h-.11L377.87,506.83h0L256.24,414.67,158.11,394l.14-.2,113-166.48h.1L334.24,239,446.06,134.09l.11.14,74.29,96L566,275.73,666.2,308.19l-.16.18L583.84,398,512.66,532Z"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    className: "cls-70",
    d: "M379,503.46,511,530.11l70.47-133,82.07-88.28-98.83-32.06h0l-45.6-44.7-74-94.72L334.66,240.46l-62-10.72L160.77,393l96.89,20.37h0Zm132.1,27H511L378.88,503.77h0L257.55,413.64l-97.29-20.46.13-.2L272.54,229.46h.1l62,10.7L445.11,136.87l.11.14,74,94.85,45.57,44.6,99.28,32.24-.18.18-82.23,88.49Z"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    className: "cls-71",
    d: "M380,500.46l129.46,28.21,69.82-132.21,82.09-87.1-98-31.88h0l-45.58-43.86L444.1,140.08l-109,101.53L274,231.88,162.91,392.17l96,20.15h0ZM509.66,529h-.12L379.89,500.76h0l-121-88.11-96.46-20.19.14-.2L274,231.61h.1l61,9.72L444.18,139.67l.11.14,73.78,93.7,45.53,43.81,98.39,32-.17.19-82.26,87.27Z"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    className: "cls-72",
    d: "M381,497.46l127,29.77,69.17-131.35L659.32,310l-97.08-31.65h0l-45.55-43L443.2,143,335.6,242.88h-.08l-60.07-8.73L165.06,391.38l95.19,19.94h0ZM508.2,527.61h-.12L380.9,497.8h0L260.14,411.72l-95.62-20,.15-.2L275.26,233.68h.11l60.09,8.78,107.75-100,.11.14,73.59,92.48,45.5,43,97.52,31.8-.19.19-82.28,86.08L508.2,527.67Z"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    className: "cls-73",
    d: "M382.05,494.39l124.52,31.32,68.5-130.52h0l82.16-84.73L561.05,279h0l-45.53-42.17-73.25-91.17L336,244H336l-59.14-7.75L167.2,390.59l94.35,19.72h0L382,494.37Zm124.7,31.72h-.09L382,494.74h0l-120.47-84-94.82-19.92.15-.21,109.85-154.8h.1l59.17,7.76,106.39-98.42.12.14,73.34,91.3,45.48,42.12,96.64,31.58-.19.2-82.32,84.89L506.78,526.1Z"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    className: "cls-74",
    d: "M383.07,491.36l122,32.88,67.85-129.71h0L655.08,311,559.8,279.8h0l-45.47-41.34-73-90L336.46,245.11l-58.29-6.78L169.37,389.82l93.5,19.51h0l120.19,82Zm122.22,33.29h-.14L382.92,491.72h0l-120.18-82-94-19.59.16-.22L278,238h.11l58.23,6.78,105-96.8.12.15,73.11,90.1,45.5,41.2,95.75,31.35-.2.21-82.34,83.71-68,129.91Z"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    className: "cls-75",
    d: "M384.08,488.33l119.58,34.43,67.2-128.9h0l82.19-82.33-94.39-31h0l-45.48-40.48-72.78-88.8-103.51,95h-.08l-57.3-5.79L171.51,389l92.66,19.28h0Zm119.75,34.86h-.17L383.93,488.66h0L264,408.66l-93.13-19.39.16-.22,108.3-149h.11l57.3,5.8,103.67-95.18.12.15,72.88,88.92,45.43,40.44,94.87,31.14-.21.21-82.37,82.52L503.86,523.16Z"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    className: "cls-76",
    d: "M385.09,485.3l117.1,36,66.55-128.09h0L651,312.07l-93.49-30.76h0L512,241.67l-72.53-87.62L337.31,247.46h-.08l-56.34-4.81L173.66,388.23l91.81,19.07h0l119.61,78Zm117.29,36.43h-.15L384.91,485.67l-119.6-78L173,388.46l.17-.23,107.53-146h.1l56.37,4.82,102.31-93.59.12.15,72.64,87.74L557.66,281l94,30.92-.21.21L569,393.46,502.38,521.77Z"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    className: "cls-77",
    d: "M175.79,387.46l91,18.85h0l119.34,76,114.61,37.53,65.92-127.3h0l82.24-80L556.3,282h0l-45.43-38.8-72.3-86.43L337.78,248.55h-.12l-55.42-3.83Zm325.13,132.8h-.15L386,482.67l-119.36-76-91.47-19,.18-.23L282.07,244.33h.1l55.43,3.83,101-91.92.12.15,72.4,86.55,45.39,38.75,93.11,30.7-.22.21L567,392.75l-66,127.5Z"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    className: "cls-78",
    d: "M177.93,386.65l90.12,18.64h0l119,74,112.14,39.09,65.25-126.46h0l82.22-78.76L555,282.86h0l-45.41-38-72.06-85.25-99.43,90.15H338l-54.32-2.9ZM499.46,518.8l-.16,0L387,479.59,267.91,405.64l-90.64-18.73.18-.24,106-140.19h.1l54.5,2.85L437.65,159l.13.15L510,244.54l45.34,37.92,92.23,30.48-.23.22-82.46,79-65.37,126.7Z"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    className: "cls-79",
    d: "M180.08,385.86l89.27,18.42h0L388.11,476.2l109.68,40.65,64.6-125.65h0l82.27-77.58-90.81-30.07h0L508.5,246.46l-71.84-84.12-98.07,88.52h-.07L285,249ZM498,517.34l-.16-.06L388,476.57,269.21,404.64,179.4,386.11l.19-.24L284.79,248.6l53.67,1.86,98.2-88.67.13.15,71.93,84.19,45.34,37.06,91.39,30.27-.24.22-82.48,77.78L498,517.35Z"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    className: "cls-80",
    d: "M182.23,385.07l88.43,18.22,118.47,69.9,107.21,42.2,64-124.84h0l82.32-76.39-89.91-29.85h0L507.39,248,435.8,165.16l-96.7,86.89H339l-52.62-.88ZM496.54,515.88l-.16-.06L389,473.54l-118.47-69.9-89-18.31.2-.25L286.13,250.74h.1l52.64.88,96.89-87.06.13.15,71.69,83,45.31,36.22,90.47,30-.24.22-82.46,76.64Z"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    className: "cls-81",
    d: "M184.37,384.28l87.61,18,118.18,67.88L494.9,513.92l63.3-124h0l82.32-75.19-89-29.63h0l-45.34-35.42L434.82,168l-95.34,85.27h-.07l-51.69.1-103.34,131ZM495.09,514.46l-.17-.07L390,470.56,271.81,402.69l-88.15-18.15.2-.25L287.51,252.87h.1l51.71-.1,95.53-85.44.13.15,71.46,81.83,45.29,35.37,89.58,29.78-.25.23-82.54,75.4Z"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    className: "cls-82",
    d: "M186.52,383.46l86.75,17.78,117.9,65.85,102.27,45.37,62.65-123.22h0l82.35-74-88.11-29.4h0L505,251.27l-71.12-80.52-94,83.64h-.08l-50.76,1.07ZM493.66,513l-.18-.07L391,467.46,273.11,401.62l-87.32-17.89.21-.26L288.87,255H289l50.79-1.08,94.17-83.81.13.15,71.22,80.64,45.27,34.59,88.7,29.6-.26.23-82.57,74.17Z"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    className: "cls-83",
    d: "M188.66,382.71l85.91,17.56,117.6,63.83L492,511l62-122.4h0l82.36-72.81-87.24-29.2-45.3-33.73L433,173.46l-92.61,82h-.07l-49.83,2.06ZM492.17,511.46l-.18-.08-100-47-117.6-63.81L187.91,382.9l.21-.27,102.1-125.58h.09L340.17,255,433,172.8l.13.15,71,79.46,45.24,33.68,87.83,29.37-.27.23-82.6,73Z"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    className: "cls-84",
    d: "M190.81,381.92l85.06,17.35,117.32,61.8,97.33,48.39,61.35-121.59h0l82.38-71.63-86.34-29-45.25-32.85L432,176.24l-91.26,80.39h-.1l-48.9,3.05-101,122.24Zm299.9,128.13-.19-.1L393,461.46,275.71,399.67l-85.66-17.46.22-.27L291.59,259.29h.09l48.92-3,91.46-80.57.14.15L503,254.15,548.16,287l87,29.16-.28.24-82.63,71.84L490.76,510.12Z"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    className: "cls-85",
    d: "M193,381.13l84.2,17.13,117,59.77L489,508l60.69-120.77h0l82.41-70.44-85.48-28.74-45.25-32-70.4-77-89.89,78.76-48,4L193,381.16ZM489.25,508.59l-.19-.1-95.05-50L277,398.73l-84.83-17.27.23-.27L293,261.46H293l48-4,90.1-79,.14.16,70.51,77.09,45.19,32,86.07,28.94-83,70.77L489.2,508.51Z"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    className: "cls-86",
    d: "M195.11,380.34l83.36,16.92L395.21,455l92.4,51.53,60-120h0L630,317.29l-84.55-28.52-45.22-31.2L430.1,181.79l-88.44,77.15h-.07l-47,5L195.17,380.33ZM487.79,507.13l-.19-.11L395,455.38l-116.7-57.73-84-17,.24-.28,99.76-116.8h.09l47.06-5,88.74-77.32.14.15,70.32,75.86,45.13,31.2L631,317.18l-.3.25L548,386.89l-60.2,120.29Z"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    className: "cls-87",
    d: "M197.26,379.55l82.46,16.68L396.22,452l89.93,53.09,59.39-119.15h0L628,317.85l-83.64-28.28-45.21-30.36-69.93-74.6L342,260.12H342l-46.11,6ZM486.34,505.67l-.21-.12L396,452.36,279.58,396.65l-83.14-16.81,99.22-114.17,46.21-6L429.25,184l.15.15,70,74.73,45.14,30.31,84.31,28.5-.3.25-82.72,68.28L486.28,505.67Z"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    className: "cls-88",
    d: "M199.41,378.77,281,395.23l116.21,53.71,87.43,54.64,58.73-118.33h0l82.47-66.87-82.75-28.06-45.18-29.51-69.7-73.42-85.8,73.88h-.06l-45.19,7L199.33,378.82ZM484.88,504.21l-.21-.13L397,449.33,280.88,395.65l-82.32-16.6.26-.29,98.22-111,45.28-7,86-74.08.15.15,69.8,73.54,45.12,29.47,83.43,28.28-.31.26-82.74,67.08L484.86,504.15Z"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    className: "cls-89",
    d: "M201.56,378l80.76,16.24,115.92,51.69,85,56.19,58.08-117.52h0l82.49-65.68L542,291.09,496.8,262.4l-69.46-72.23-84.43,72.29h-.06l-44.19,7.89ZM483.42,502.76l-.22-.14L398,446.3,282.18,394.65l-81.52-16.38.27-.3,97.44-108,44.35-8,84.66-72.46.15.16L497.1,262l45.12,28.64,82.53,28-.33.26-82.76,65.9Z"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    className: "cls-90",
    d: "M203.71,377.19l79.91,16,115.63,49.67,82.53,57.74,57.43-116.7h0l82.51-64.44-80.9-27.59L495.66,264l-69.23-71.06-83.07,70.64h-.06L300,272.46l-96.28,104.7ZM482,501.3l-.22-.15L399,443.27,283.48,393.65l-80.66-16.19.27-.3,96.67-105.11h.07l43.34-8.93,83.31-70.83.15.15L496,263.61l45.1,27.79,81.65,27.84-.33.26-82.8,64.72Z"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    className: "cls-91",
    d: "M205.86,376.4l79.06,15.81,115.34,47.63,80.07,59.3L537.1,383.26h0L619.66,320l-80-27.35-45.2-27-68.94-69.84-81.71,69-42.46,9.93L205.82,376.46ZM480.5,499.85l-.23-.17L400,440.25l-115.25-47.6L204.94,376.7l.29-.31L301.12,274.2h.06l42.42-9.92,82-69.21,69.23,70.12,45.09,27,80.74,27.57-.34.27-82.83,63.53-57,116.29Z"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    className: "cls-92",
    d: "M208,375.61l78.21,15.6L401.3,436.82h0l77.55,60.81L535,382.56h0l82.56-62.1-79.1-27.13-45.18-26.2L424.6,198.46l-80.35,67.38h0l-41.47,10.89-94.72,98.85ZM479,498.39l-.23-.18-77.75-61L286,391.63l-79-15.75.3-.31,95.11-99.26h.06L344,265.41l80.67-67.58.16.15,68.84,68.79,45,26.12,79.9,27.4L535.35,382.9,479,498.39Z"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    className: "cls-93",
    d: "M210.16,374.83l77.36,15.37,114.79,43.59h0l75.07,62.36L532.85,381.9h0L615.41,321l-78.2-26.9-45.15-25.35-68.4-67.48-79,65.75h0l-40.55,11.88-93.93,95.93ZM477.58,496.94l-.24-.2-75.27-62.53L287.39,390.66,209.2,375.12l.31-.31,94.33-96.35,40.62-11.9,79.23-66,.16.15,68.6,67.6,45,25.28,79,27.18L533.2,382.19l-55.68,114.7Z"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    className: "cls-94",
    d: "M212.31,374l76.51,15.15,114.51,41.57h0l72.6,63.91,54.81-113.44h0l82.61-59.77-77.3-26.68L491,270.28,422.74,204l-77.62,64.13h0L305.5,281l-93.15,93ZM476.12,495.46l-.24-.21-72.81-64.08L288.66,389.66l-77.37-15.32.32-.32,93.56-93.41h0l39.63-12.87,77.86-64.34L491.18,270l45,24.43,78.15,27L531,381.65,476,495.54Z"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    className: "cls-95",
    d: "M214.46,373.25l75.66,14.94,114.22,39.54h0l70.12,65.44,54.2-112.57h.06l82.6-58.54-76.41-26.45L489.8,272l-68-65.1-76.25,62.5h0l-38.7,13.85-92.36,90.08ZM474.66,494l-.25-.23-70.33-65.63L290,388.66l-76.54-15.11.33-.32,92.78-90.49h0l38.7-13.85,76.52-62.72.16.15,68.13,65.23,45,23.59,77.27,26.75-.39.28L529,381Z"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    className: "cls-96",
    d: "M216.66,372.46l74.8,14.72L405.39,424.7h0l67.66,67,53.5-111.79h.06l82.62-57.35-75.51-26.23-45.06-22.82L420.9,209.59,346,270.46l-37.8,14.84ZM473.24,492.58l-.25-.25-67.87-67.19L291.33,387.67l-75.67-14.9.35-.33,92-87.57h0L345.79,270,421,208.93l.15.15,67.89,64,45,22.75,76.4,26.53-.4.28-83,57.59L473.25,492.59Z"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    className: "cls-97",
    d: "M218.77,371.68l74,14.5,113.65,35.49v.05l65.18,68.53,52.86-111h0l82.64-56.17-74.6-26-45.07-22-67.52-62.74L346.36,271.6l-36.8,15.86L218.77,371.7Zm253,119.45-.25-.27-65.39-68.74L292.66,386.67l-75-14.69.37-.33L309.25,287h0l36.84-15.82,73.82-59.47.16.15,67.65,62.86,44.94,21.9,75.53,26.31-.42.29-83,56.41L471.66,491.15Z"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    className: "cls-98",
    d: "M220.92,370.89,294,385.17l113.36,33.47v.06l62.71,70.06,52.2-110.15h.06l82.65-55-73.71-25.77-45-21.13L419,215.16l-72.13,57.6-36,16.82-90,81.32ZM470.27,489.68,407.1,419.09,293.9,385.67,219.82,371.2l.38-.35,90.46-81.71h0l36-16.82,72.39-57.86.16.15,67.45,61.69,44.92,21.05,74.65,26.1-.43.29L522.8,379,470.33,489.68Z"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    className: "cls-99",
    d: "M223.08,370.1l72.24,14.07L408.4,415.61v.06l60.26,71.61L520.2,378h.06l82.67-53.79-72.8-25.54-45-20.28-67-60.38-70.78,56-35,17.81-89.21,78.39ZM468.81,488.23l-.26-.31L408.1,416.07l-112.9-31.4-73.26-14.21.4-.35L312,291.31l35-17.79,71.08-56.23.16.15,67.18,60.5,44.89,20.21L604.11,324l-.44.29-83,54L468.84,488.25Z"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    className: "cls-100",
    d: "M225.23,369.32l71.43,13.84,112.79,29.42.06.07,57.76,73.14,50.89-108.51,82.75-52.64L529,299.33l-45-19.44-66.8-59.19-69.42,54.36-34.13,18.8-88.4,75.46ZM467.35,486.78l-58.24-73.73L296.5,383.68l-72.44-14.05.41-.36,88.86-75.81,34.13-18.81,69.73-54.6.16.14,66.94,59.27,44.87,19.37,72.91,25.63-83.54,53.13L467.35,486.73Z"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    className: "cls-101",
    d: "M227.39,368.53l70.53,13.63,112.51,27.39.06.08,55.29,74.67L516,376.62h.06l82.71-51.41-71-25.09-45-18.59-66.57-58-68.06,52.73L315,296l-87.61,72.55ZM465.88,485.34l-.26-.36-55.5-75L297.8,382.64,226.18,368.8l.43-.36,88-72.88,33.18-19.79,68.38-53,.17.14L483,281l44.84,18.52,72,25.45-.47.3L516.3,377,465.76,485.32Z"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    className: "cls-102",
    d: "M229.55,367.74l69.67,13.41,112.22,25.37,52.89,76.29L513.9,376H514l82.69-50.26-70.09-24.85-45-17.75-66.33-56.83-66.58,51.11-32.24,20.75-86.83,69.62ZM464.42,483.89,411.12,407l-112-25.32-70.8-13.63,87.76-70.37,32.25-20.76,67-51.36.16.15L482,282.65l44.82,17.68,71.16,25.23-83.62,50.77-49.9,107.56Z"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    className: "cls-103",
    d: "M231.71,367l68.8,13.19,112,23.34.06.09,50.36,77.74,48.91-106h.07l82.73-49L525.45,301.7l-44.92-16.91-66.1-55.64L349.1,278.63l-31.3,21.74-86,66.7ZM463,482.46l-.27-.42L412.12,404l-111.71-23.3-70-13.41.48-.38,86.54-67.08,31.3-21.73,65.67-49.74.17.14,66.22,55.75,44.79,16.84,70.3,25-83.66,49.59Z"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    className: "cls-104",
    d: "M233.87,366.17l179.61,34.29.06.1,47.89,79.26,48.23-105.19.08-.05,82.74-47.84L479.33,286.31h0l-65.86-54.46Z"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    className: "cls-105",
    d: "M17.66,198.59c3.34-1,6.58,3.56,9.88,12.35s6.58,21.8,10.52,37.12c2.15,8.36,4.45,17.31,6.93,26.16s5.14,17.6,8,25.44c5.27,14.62,12.36,24.87,19.06,29.16s4.81,7.44-2.22,10.32-18.89,3.16-28.75-4.07c-8.19-6-15.3-15.83-22.4-27.45-6.21-10.16-12.47-22.17-18.84-33.1s-12.92-20.63-19.13-27.34c-8.83-9.55-13.81-16-14-22.85s3.94-13.05,9-16.93c5.71-4.38,12.57-6.3,19.85-6.87C3.74,199.87,12.15,200.2,17.66,198.59Z"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    className: "cls-106",
    d: "M18.81,200.32c3.38-.89,6.65,3.67,10,12.44s6.64,21.73,10.66,36.91C41.68,258,44,266.86,46.6,275.59s5.32,17.3,8.23,25c5.4,14.21,12.56,24,19.2,28.12s4.77,7.36-2.26,10.49-19,4.19-29-2.39C34.4,331.3,27.18,321.89,20,310.52c-6.26-9.95-12.54-21.88-18.86-32.95s-12.74-21.11-18.81-28.27c-8.56-10.09-13.38-17.05-13.61-24.05s3.61-13.07,8.47-16.85c5.52-4.3,12.24-6.12,19.47-6.56,8.15-.5,16.6,0,22.21-1.48Z"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    className: "cls-107",
    d: "M20,202.05c3.43-.8,6.73,3.78,10.1,12.53s6.71,21.65,10.82,36.66c2.26,8.26,4.71,17,7.35,25.64s5.5,17,8.5,24.44c5.56,13.8,12.72,23.13,19.31,27.14s4.73,7.28-2.29,10.66-19.18,5.18-29.32-.75c-8.57-5-15.9-14-23.13-25.11-4.22-6.48-8.43-13.89-12.63-21.43S.3,276.65-3.86,269.69a184.41,184.41,0,0,0-12.27-18.23c-8.3-10.6-13-18.09-13.28-25.23a20.47,20.47,0,0,1,8-16.82c5.35-4.24,11.93-6,19.11-6.28,8.08-.35,16.56.3,22.31-1Z"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    className: "cls-108",
    d: "M21.17,203.8c3.48-.72,6.82,3.87,10.23,12.59s6.79,21.55,11,36.37c2.33,8.2,4.85,16.88,7.59,25.33s5.69,16.66,8.79,23.9c5.71,13.36,12.84,22.29,19.36,26.18s4.7,7.23-2.31,10.84-19.27,6.13-29.56.86c-8.76-4.49-16.21-13-23.53-23.89-4.26-6.32-8.51-13.63-12.72-21.13s-8.4-15.2-12.52-22.29a223.8,223.8,0,0,0-12.08-18.89c-8.06-11.07-12.57-19.08-13-26.37a20.2,20.2,0,0,1,7.51-16.83c5.17-4.2,11.61-5.84,18.75-6C6.75,204.22,15.28,205,21.17,203.8Z"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    className: "cls-109",
    d: "M22.35,205.56c3.54-.64,6.91,4,10.37,12.64s6.89,21.43,11.21,36c2.4,8.12,5,16.68,7.84,25s5.89,16.29,9.09,23.31C66.74,315.42,74,324.1,80.23,327.8s4.67,7.18-2.33,11-19.33,7-29.77,2.43c-9-4-16.53-12-23.94-22.63-4.31-6.15-8.59-13.34-12.83-20.8S3,282.62-1.14,275.41-9.25,261.53-13,256c-7.85-11.5-12.19-20-12.64-27.49a20.08,20.08,0,0,1,7-16.88c5-4.18,11.32-5.74,18.42-5.82,8-.09,16.52.85,22.57-.25Z"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    className: "cls-110",
    d: "M23.54,207.33c3.59-.58,7,4,10.51,12.67s7,21.29,11.43,35.69c2.48,8,5.18,16.47,8.12,24.6q4.13,11.55,9.38,22.64c5.93,12.3,13.16,20.93,19.35,24.5S87,334.58,80,338.61s-19.37,7.91-29.95,4c-9.17-3.42-16.87-11.06-24.37-21.34a227.34,227.34,0,0,1-13-20.42c-4.26-7.4-8.45-15.13-12.52-22.44s-8-14.17-11.77-20c-7.65-11.89-11.84-20.93-12.35-28.55s2.51-13.45,6.62-17c4.85-4.17,11-5.66,18.1-5.64,7.89,0,16.52,1.11,22.73.12Z"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    className: "cls-111",
    d: "M24.72,209.11c3.66-.51,7.12,4.1,10.68,12.68s7.13,21.13,11.68,35.29c2.55,7.94,5.36,16.24,8.4,24.18s6.39,15.44,9.66,21.95c6,11.91,13.17,20.31,19.3,23.76s4.62,7.12-2.33,11.36S62.75,347,52,343.75c-9.38-2.88-17.21-10.05-24.81-20a201.64,201.64,0,0,1-13.1-20c-4.3-7.32-8.5-15.05-12.55-22.44s-8-14.42-11.66-20.44c-7.48-12.24-11.5-21.78-12.07-29.58s2.26-13.61,6.21-17.12c4.68-4.17,10.75-5.6,17.79-5.48,7.84.14,16.52,1.34,22.89.46Z"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    className: "cls-112",
    d: "M25.92,210.89c3.71-.44,7.23,4.17,10.85,12.67s7.27,21,12,34.86c2.63,7.83,5.54,16,8.7,23.72s6.6,14.93,9.9,21.26c6,11.53,13.18,19.71,19.24,23.06,6.24,3.43,4.6,7.11-2.32,11.53S65,347.46,54.1,344.83c-9.59-2.33-17.56-9-25.28-18.68a182.72,182.72,0,0,1-13.25-19.58C11.23,299.35,7,291.63,3,284.18s-8-14.62-11.58-20.85c-7.32-12.56-11.19-22.57-11.82-30.56s2-13.81,5.82-17.29c4.53-4.19,10.49-5.57,17.49-5.36,7.81.24,16.54,1.56,23.1.77Z"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    className: "cls-113",
    d: "M27.11,212.68c3.78-.39,7.36,4.22,11,12.65s7.42,20.74,12.24,34.37c2.73,7.71,5.74,15.69,9,23.23s6.79,14.41,10.12,20.56c6,11.18,13.17,19.15,19.18,22.4,6.19,3.35,4.58,7.11-2.31,11.72s-19.23,10.16-30.26,8.18c-9.81-1.75-17.91-8-25.75-17.29A164.14,164.14,0,0,1,16.9,309.38c-4.39-7.12-8.64-14.8-12.7-22.29s-7.92-14.8-11.51-21.22C-14.49,253-18.23,242.58-18.9,234.39s1.81-14,5.44-17.51c4.39-4.21,10.24-5.56,17.22-5.26,7.76.33,16.56,1.76,23.29,1.06Z"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    className: "cls-114",
    d: "M28.31,214.46c3.85-.35,7.49,4.24,11.26,12.59s7.58,20.51,12.55,33.84c2.82,7.59,6,15.39,9.35,22.7s6.94,13.9,10.29,19.88c6.08,10.83,13.16,18.61,19.1,21.78,6.15,3.27,4.57,7.12-2.29,11.9s-19.1,10.79-30.29,9.47c-10-1.18-18.28-6.92-26.23-15.89a147,147,0,0,1-13.62-18.61C14,305.12,9.69,297.49,5.62,290s-8-14.92-11.48-21.5c-7.06-13.08-10.66-24-11.39-32.35s1.61-14.28,5.09-17.76c4.25-4.26,10-5.57,17-5.2C12.52,213.56,21.39,215.09,28.31,214.46Z"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    className: "cls-115",
    d: "M29.52,216.27c3.92-.3,7.63,4.27,11.48,12.53s7.76,20.25,12.88,33.26c2.93,7.44,6.21,15.14,9.7,22.11S70.64,297.58,74,303.4c6.1,10.5,13.13,18.1,19,21.19,6.11,3.22,4.55,7.15-2.26,12.09S71.82,348,60.48,347.38c-10.27-.6-18.65-5.85-26.73-14.46a133.3,133.3,0,0,1-13.83-18.08c-4.5-6.89-8.85-14.45-12.94-22s-7.94-15-11.47-21.78c-7-13.29-10.44-24.56-11.21-33.17s1.4-14.54,4.75-18c4.11-4.33,9.75-5.61,16.7-5.16C13.46,215.2,22.4,216.82,29.52,216.27Z"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    className: "cls-116",
    d: "M30.74,218.07c4-.26,7.77,4.28,11.71,12.43s8,20,13.25,32.65c3,7.28,6.48,14.71,10,21.45s7.17,13,10.57,18.63c6.11,10.19,13.08,17.62,18.91,20.65,6.07,3.16,4.54,7.18-2.23,12.27S74.21,348,62.72,348c-10.5,0-19-4.76-27.25-13a122,122,0,0,1-14-17.54c-4.57-6.74-9-14.21-13.1-21.74s-8-15.11-11.48-22c-6.88-13.47-10.26-25.08-11.07-33.91S-13,225-9.75,221.45c4-4.39,9.53-5.66,16.47-5.16,7.67.55,16.69,2.25,24,1.77Z"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    className: "cls-117",
    d: "M32,219.86c4.07-.23,7.92,4.28,12,12.31s8.17,19.66,13.62,32q4.71,10.6,10.36,20.77c3.62,6.5,7.28,12.53,10.7,18,6.13,9.89,13,17.16,18.8,20.14,6,3.12,4.53,7.22-2.19,12.45A69.5,69.5,0,0,1,65.1,348.46C54.37,350,45.67,344.88,37.32,337A112.15,112.15,0,0,1,23,320,236.32,236.32,0,0,1,9.78,298.56c-4.16-7.51-8-15.14-11.53-22.15-6.81-13.61-10.1-25.52-10.95-34.59s1-15.14,4.12-18.71c3.87-4.47,9.32-5.74,16.26-5.19,7.64.61,16.74,2.38,24.3,2Z"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    className: "cls-118",
    d: "M33.22,221.66c4.15-.21,8.09,4.26,12.23,12.16s8.39,19.32,14,31.27c3.27,6.94,7,13.78,10.65,20.06s7.39,12.11,10.82,17.49c6.14,9.61,13,16.73,18.68,19.67,6,3.1,4.52,7.28-2.14,12.64a73.11,73.11,0,0,1-30,13.68c-10.84,2-19.81-2.29-28.31-9.75a103,103,0,0,1-14.49-16.37,212,212,0,0,1-13.47-21.16C7,293.88,3.1,286.21-.4,279.09c-6.76-13.72-10-25.9-10.86-35.2s.87-15.48,3.83-19.09c3.75-4.57,9.11-5.84,16-5.24,7.63.65,16.82,2.48,24.61,2.1Z"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    className: "cls-119",
    d: "M34.48,223.46c4.24-.18,8.26,4.23,12.51,12s8.64,19,14.46,30.52c3.4,6.74,7.19,13.27,10.93,19.33s7.48,11.71,10.93,17c6.13,9.34,12.9,16.31,18.54,19.23,6,3.08,4.52,7.34-2.08,12.83A77.19,77.19,0,0,1,69.9,348.83c-10.93,2.45-20.17-1-28.82-8.09-7.47-6.09-15-15.23-21.82-25.71A307.51,307.51,0,0,1,.94,281.86c-6.72-13.79-9.88-26.2-10.81-35.74s.71-15.83,3.55-19.49c3.64-4.69,8.92-6,15.87-5.34C17.17,221.92,26.44,223.8,34.48,223.46Z"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    className: "cls-120",
    d: "M35.75,225.22c4.33-.17,8.45,4.19,12.81,11.79s8.9,18.56,14.92,29.7c3.53,6.54,7.37,12.76,11.17,18.61s7.58,11.32,11,16.44c6.13,9.08,12.82,15.93,18.41,18.83,5.91,3.07,4.52,7.41-2,13S84,345.73,72.35,348.77c-11,2.88-20.52.22-29.32-6.42-7.6-5.74-15.24-14.55-22.22-24.84a265,265,0,0,1-18.54-33c-6.7-13.84-9.82-26.41-10.78-36.2s.56-16.2,3.29-19.93c3.52-4.81,8.73-6.11,15.68-5.45,7.62.72,17,2.64,25.28,2.3Z"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    className: "cls-121",
    d: "M37,227c4.42-.17,8.64,4.12,13.13,11.56s9.22,18.22,15.39,28.83c3.64,6.26,7.54,12.25,11.4,17.88s7.65,11,11.12,15.95c6.13,8.84,12.73,15.57,18.26,18.47,5.87,3.07,4.52,7.48-2,13.2S86.4,345.31,74.81,348.74C63.7,352,54,350.18,45,344c-7.73-5.37-15.52-13.85-22.63-23.92a234.81,234.81,0,0,1-18.8-32.82c-6.7-13.87-10.2-25.6-10.81-36.56s.43-16.62,3-20.43c3.42-5,8.56-6.26,15.53-5.59C19,225.38,28.49,227.33,37,227Z"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    className: "cls-122",
    d: "M38.34,228.75c4.53-.18,8.86,4,13.48,11.3s9.58,17.76,15.86,27.88c3.73,6,7.7,11.76,11.61,17.2S87,295.72,90.49,300.6c6.12,8.61,12.65,15.23,18.12,18.13,5.82,3.09,4.52,7.57-1.87,13.39S89,344.81,77.4,348.6c-11.19,3.68-21.16,2.65-30.28-3.15-7.86-5-15.82-13.13-23.06-23A213.08,213.08,0,0,1,5,289.89C-1.74,276-5.24,264.14-5.93,253.12s.33-17.11,2.85-21c3.32-5.11,8.39-6.47,15.38-5.78,7.63.75,17.22,2.72,26,2.36Z"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    className: "cls-123",
    d: "M39.66,230.46c4.63-.19,9.07,3.93,13.83,11s9.94,17.23,16.34,26.88c3.81,5.76,7.85,11.28,11.8,16.53s7.81,10.24,11.29,15c6.1,8.39,12.54,14.91,18,17.82,5.79,3.11,4.54,7.67-1.78,13.58S91.54,344.19,80,348.33c-11.26,4-21.44,3.8-30.74-1.56-8-4.6-16.12-12.39-23.51-22A190.6,190.6,0,0,1,6.36,292.54c-6.73-13.82-10.25-25.85-11-37S-4.41,238-2,234c3.22-5.27,8.22-6.65,15.24-6,7.64.75,17.35,2.72,26.46,2.35Z"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    className: "cls-124",
    d: "M41,232.22c4.74-.2,9.3,3.83,14.21,10.69S65.53,259.55,72,268.74c3.9,5.52,8,10.81,12,15.87s7.88,9.91,11.36,14.59c6.08,8.18,12.44,14.62,17.79,17.54,5.74,3.14,4.54,7.77-1.69,13.77S94.08,343.65,82.6,348.1s-21.72,4.92-31.18,0c-8.14-4.22-16.43-11.64-24-21S13.18,306.46,7.66,295.32C.89,281.57-2.66,269.43-3.49,258.27s.12-18.06,2.46-22.12c3.13-5.45,8.07-6.88,15.12-6.21C21.77,230.67,31.6,232.64,41,232.22Z"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    className: "cls-125",
    d: "M42.39,233.93c4.85-.24,9.54,3.69,14.61,10.33s10.66,16,17.24,24.74c4,5.28,8.15,10.36,12.19,15.24s7.94,9.59,11.42,14.17c6.06,8,12.33,14.35,17.63,17.3,5.69,3.18,4.55,7.88-1.6,14S96.69,343,85.26,347.78s-22,6-31.6,1.55c-8.28-3.82-16.75-10.87-24.45-19.92S14.63,309.18,9.06,298c-6.83-13.66-10.42-25.89-11.33-37.1s0-18.51,2.27-22.68c3-5.63,7.93-7.12,15-6.46,7.69.71,17.65,2.66,27.38,2.18Z"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    className: "cls-126",
    d: "M43.79,235.62c5-.28,9.8,3.53,15,9.93s11,15.31,17.68,23.62c4.06,5.05,8.29,9.92,12.37,14.62s8,9.28,11.47,13.78c6,7.8,12.22,14.09,17.46,17.08,5.65,3.23,4.57,8-1.48,14.14S99.29,342.3,88,347.31s-22.19,7-32,3c-8.43-3.42-17.07-10.1-25-18.85s-14.9-19.74-20.56-30.87C3.49,287.05-.15,274.74-1.15,263.5s-.09-18.94,2.08-23.22c3-5.84,7.79-7.38,14.92-6.76,7.72.68,17.81,2.6,27.88,2Z"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    className: "cls-127",
    d: "M45.21,237.28c5.1-.32,10.06,3.35,15.46,9.5S72,261.36,78.77,269.25c4.13,4.83,8.42,9.48,12.54,14s8,9,11.52,13.4c6,7.63,12.1,13.87,17.28,16.9,5.61,3.28,4.59,8.11-1.36,14.33s-16.75,13.66-28,18.92c-11.49,5.35-22.4,8-32.4,4.5-8.58-3-17.4-9.31-25.46-17.75s-15.23-19.22-21-30.3c-7-13.41-10.68-25.76-11.77-37S-.09,246.9,2,242.51c2.88-6,7.67-7.66,14.85-7.07C24.56,236.05,34.8,237.93,45.21,237.28Z"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    className: "cls-128",
    d: "M46.66,238.91c5.23-.37,10.35,3.16,15.93,9s11.65,13.81,18.49,21.3c8.41,9.21,17.33,17.81,24.27,26.48,6,7.48,12,13.66,17.09,16.74,5.58,3.34,4.62,8.24-1.23,14.51s-16.5,13.8-27.72,19.29c-11.52,5.63-22.57,8.93-32.77,5.89-8.73-2.59-17.74-8.5-26-16.62s-15.59-18.67-21.47-29.68c-7.07-13.23-10.85-25.62-12-36.91s-.33-19.74,1.69-24.25c2.8-6.27,7.54-8,14.78-7.42,7.79.58,18.18,2.4,29,1.63Z"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    className: "cls-129",
    d: "M48.14,240.51c5.37-.43,10.64,2.94,16.41,8.53s12,13,18.86,20.13C92,278,101,286.22,107.87,294.75c5.94,7.32,11.84,13.46,16.91,16.6,5.54,3.42,4.64,8.37-1.09,14.7S107.44,340,96.31,345.65c-11.55,5.91-22.74,9.8-33.12,7.25-8.89-2.18-18.08-7.69-26.51-15.47s-16-18.09-22-29c-7.18-13-11-25.44-12.34-36.74S1.89,251.6,3.83,247c2.73-6.51,7.44-8.28,14.73-7.8,7.85.52,18.39,2.28,29.54,1.36Z"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    className: "cls-130",
    d: "M49.66,242.08c5.51-.51,11,2.66,16.92,8S78.8,262.31,85.77,269c8.7,8.36,17.75,16.32,24.65,24.72,5.9,7.18,11.71,13.29,16.73,16.48,5.49,3.5,4.67,8.51-1,14.89s-16,14-27,19.89c-11.56,6.16-22.87,10.59-33.44,8.54-9-1.75-18.43-6.85-27.06-14.29S22.31,321.78,16.17,311c-7.29-12.83-11.25-25.2-12.66-36.51S2.92,254,4.8,249.25c2.65-6.76,7.33-8.61,14.69-8.2,7.9.45,18.61,2.12,30.15,1Z"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    className: "cls-131",
    d: "M51.19,243.62c5.67-.6,11.33,2.46,17.44,7.39s12.48,11.42,19.52,17.76c8.83,8,17.93,15.61,24.81,23.9,5.86,7.05,11.58,13.13,16.54,16.4,5.45,3.58,4.7,8.65-.8,15.06S113,338.22,102.06,344.27c-11.57,6.4-23,11.33-33.75,9.78-9.22-1.32-18.79-6-27.61-13.12s-16.75-16.82-23-27.5a97.8,97.8,0,0,1-13-36.24C3.17,265.91,4,256.46,5.77,251.57c2.59-7,7.23-9,14.67-8.63,8,.36,18.84,1.94,30.79.67Z"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    className: "cls-132",
    d: "M52.77,245.11c5.82-.7,11.71,2.19,18,6.74s12.69,10.61,19.78,16.61c9,7.56,18.12,14.94,25,23.11,5.81,6.94,11.43,13,16.34,16.34,5.4,3.67,4.74,8.79-.64,15.24S115.86,337.3,105,343.51a104,104,0,0,1-17.2,8.14c-5.69,2-11.36,3.33-16.85,2.81-9.37-.89-19.14-5.19-28.17-11.91s-17.16-16.16-23.6-26.69A95.42,95.42,0,0,1,5.82,280c-1.65-11.25-.9-21,.85-26,2.52-7.27,7.14-9.32,14.65-9.08,8,.26,19.1,1.73,31.47.25Z"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    className: "cls-133",
    d: "M54.39,246.56c6-.8,12.1,1.87,18.49,6s13,9.86,20.1,15.5c9.09,7.17,18.29,14.28,25.12,22.36,5.77,6.82,11.3,12.88,16.15,16.29,5.36,3.77,4.78,9-.46,15.42S118.7,336.34,108,342.67a109.74,109.74,0,0,1-17.25,8.53c-5.73,2.15-11.48,3.8-17.07,3.53-9.55-.44-19.51-4.34-28.74-10.69s-17.59-15.45-24.19-25.82A93.33,93.33,0,0,1,6.94,282.7c-1.78-11.22-1.08-21.2.61-26.39,2.46-7.53,7.06-9.69,14.65-9.55C30.31,246.93,41.57,248.28,54.39,246.56Z"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    className: "cls-134",
    d: "M56.05,248c6.15-.92,12.48,1.48,19,5.28s13.19,9.1,20.38,14.41c9.21,6.79,18.45,13.65,25.25,21.64,5.72,6.73,11.15,12.79,16,16.28,5.32,3.87,4.82,9.1-.28,15.59S121.64,335.39,111,341.85a115.93,115.93,0,0,1-17.27,8.89,56.38,56.38,0,0,1-17.29,4.17c-9.76.6-19.88-3.44-29.33-9.41s-18-14.75-24.8-24.92A91.13,91.13,0,0,1,8.08,285.46c-1.91-11.17-1.26-21.4.37-26.72,2.4-7.83,7-10.1,14.66-10.07,8.2,0,19.65,1.24,32.94-.75Z"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    className: "cls-135",
    d: "M57.74,249.31c6.33-1,12.86,1,19.51,4.48s13.42,8.37,20.65,13.35c9.33,6.43,18.6,13.06,25.37,21,5.67,6.64,11,12.7,15.76,16.28,5.28,4,4.86,9.25-.1,15.76S124.51,334.42,114,341a122,122,0,0,1-17.29,9.23,60.68,60.68,0,0,1-17.49,4.7c-9.93,1-20.26-2.48-29.93-8.06a81,81,0,0,1-25.43-24,88.88,88.88,0,0,1-14.68-34.6c-2-11.11-1.46-21.55.12-27,2.34-8.11,6.9-10.5,14.69-10.6C32.31,250.54,44,251.6,57.74,249.31Z"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    className: "cls-136",
    d: "M59.49,250.61c6.51-1.2,13.23.56,20,3.64s13.63,7.66,20.9,12.33c9.45,6.08,18.74,12.48,25.48,20.34,5.61,6.55,10.86,12.62,15.56,16.29,5.23,4.1,4.91,9.41.1,15.93s-14.07,14.24-24.4,20.9a125.38,125.38,0,0,1-17.29,9.54,64.74,64.74,0,0,1-17.7,5.22c-10.09,1.33-20.63-1.54-30.52-6.73a78,78,0,0,1-26.08-23A86,86,0,0,1,10.38,291c-2.2-11-1.69-21.65-.16-27.27,2.29-8.41,6.84-10.93,14.73-11.16,8.38-.24,20.26.65,34.54-2Z"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    className: "cls-137",
    d: "M61.27,251.85c6.71-1.35,13.59,0,20.48,2.78s13.84,7,21.15,11.34c9.56,5.73,18.87,11.93,25.57,19.73,5.57,6.48,10.72,12.57,15.37,16.34,5.19,4.21,5,9.56.3,16.09s-13.71,14.23-23.89,21A129.31,129.31,0,0,1,103,349a68.94,68.94,0,0,1-17.88,5.7c-10.25,1.67-21-.63-31.13-5.41a75.07,75.07,0,0,1-26.75-22,83.43,83.43,0,0,1-15.67-33.5c-2.34-10.95-1.91-21.71-.44-27.47,2.23-8.72,6.78-11.37,14.79-11.75,8.48-.4,20.58.31,35.38-2.67Z"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    className: "cls-138",
    d: "M63.1,253c6.91-1.52,13.94-.49,21,1.91s14,6.27,21.37,10.37c9.67,5.41,19,11.42,25.66,19.17,5.51,6.41,10.58,12.53,15.17,16.39,5.15,4.33,5,9.73.52,16.26s-13.33,14.2-23.36,21a134.9,134.9,0,0,1-17.25,10.12,74.4,74.4,0,0,1-18.06,6.16c-10.42,2-21.41.26-31.75-4.13A72.61,72.61,0,0,1,29,329.34a80.68,80.68,0,0,1-16.2-32.87c-2.5-10.85-2.17-21.72-.74-27.63,2.18-9,6.72-11.81,14.85-12.36,4.29-.28,9.46-.14,15.53-.5A134.36,134.36,0,0,0,63.15,253Z"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    className: "cls-139",
    d: "M65,254.13c7.12-1.7,14.26-1.06,21.39,1s14.23,5.62,21.58,9.44c9.78,5.09,19.13,10.93,25.74,18.65,5.45,6.35,10.43,12.5,15,16.46,5.11,4.46,5.09,9.89.75,16.41s-13,14.16-22.81,21a138.2,138.2,0,0,1-17.24,10.37,79.28,79.28,0,0,1-18.22,6.6c-10.58,2.32-21.81,1.11-32.38-2.87a70.52,70.52,0,0,1-28.13-19.83A77.77,77.77,0,0,1,13.9,299.15c-2.66-10.76-2.44-21.69-1.06-27.76,2.13-9.35,6.67-12.27,14.93-13,4.35-.38,9.61-.34,15.83-.83A139.11,139.11,0,0,0,65,254.11Z"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    className: "cls-140",
    d: "M66.91,255.18a43.89,43.89,0,0,1,21.81.1c7.23,1.75,14.41,5,21.79,8.55,9.88,4.78,19.23,10.46,25.8,18.15,5.4,6.3,10.29,12.49,14.78,16.55,5.06,4.58,5.14,10.05,1,16.56s-12.55,14.1-22.24,21a141.74,141.74,0,0,1-17.19,10.6,83.44,83.44,0,0,1-18.38,7,60,60,0,0,1-33-1.65,69,69,0,0,1-28.84-18.75,75.09,75.09,0,0,1-17.33-31.5c-2.84-10.63-2.73-21.61-1.4-27.82,2.08-9.68,6.63-12.75,15-13.65,4.42-.47,9.77-.54,16.14-1.17A141.11,141.11,0,0,0,66.91,255.18Z"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    className: "cls-141",
    d: "M68.88,256.13a46.25,46.25,0,0,1,22.21-.78c7.34,1.43,14.59,4.35,22,7.67,10,4.49,19.33,10,25.87,17.7,5.33,6.26,10.13,12.49,14.57,16.66,5,4.71,5.21,10.21,1.23,16.71s-12.13,14-21.65,20.94A143.54,143.54,0,0,1,116,345.86a89,89,0,0,1-18.52,7.42,63.33,63.33,0,0,1-33.65-.46A67.74,67.74,0,0,1,34.3,335.19a72.2,72.2,0,0,1-18-30.73c-3-10.5-3-21.47-1.75-27.84,2-10,6.58-13.23,15.11-14.33,4.48-.57,9.94-.76,16.47-1.54a140.51,140.51,0,0,0,22.7-4.6Z"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    className: "cls-142",
    d: "M70.87,257a49.06,49.06,0,0,1,22.61-1.65c7.44,1.14,14.76,3.76,22.17,6.84,10.08,4.2,19.43,9.62,25.91,17.29,5.27,6.23,10,12.5,14.38,16.77,5,4.84,5.28,10.37,1.48,16.85s-11.71,14-21,20.88a143.41,143.41,0,0,1-17,11,92.16,92.16,0,0,1-18.66,7.8A67.09,67.09,0,0,1,36.18,337a69.57,69.57,0,0,1-18.54-30c-3.2-10.36-3.37-21.3-2.13-27.82,2-10.33,6.55-13.72,15.23-15,4.55-.68,10.11-1,16.81-1.94A140.88,140.88,0,0,0,70.87,257Z"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    className: "cls-143",
    d: "M72.9,257.76a51.76,51.76,0,0,1,23-2.48c7.55.84,14.93,3.17,22.34,6,10.18,3.93,19.52,9.24,26,16.9,5.21,6.21,9.84,12.53,14.18,16.9,4.94,5,5.36,10.54,1.74,17s-11.26,13.86-20.41,20.79a145.13,145.13,0,0,1-16.9,11.21,97.51,97.51,0,0,1-18.78,8.17A71.34,71.34,0,0,1,69.13,354a66.31,66.31,0,0,1-50.21-44.46c-3.39-10.21-3.72-21.06-2.52-27.73,1.92-10.67,6.52-14.22,15.35-15.75,4.63-.8,10.3-1.25,17.17-2.37a143.56,143.56,0,0,0,24-6Z"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    className: "cls-144",
    d: "M75,258.46a55,55,0,0,1,23.37-3.31c7.64.56,15.08,2.62,22.5,5.27,10.27,3.66,19.6,8.88,26,16.56,5.15,6.18,9.7,12.55,14,17,4.9,5.11,5.43,10.69,2,17.12S152,324.86,143.07,331.79a146.27,146.27,0,0,1-16.78,11.37,101.81,101.81,0,0,1-18.9,8.51A76.16,76.16,0,0,1,71.8,354.5,67.19,67.19,0,0,1,40,340.36a64.7,64.7,0,0,1-19.84-28.27c-3.58-10-4.09-20.79-2.93-27.6,1.87-11,6.49-14.73,15.48-16.5,4.71-.92,10.5-1.5,17.54-2.81A150,150,0,0,0,75,258.46Z"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    className: "cls-145",
    d: "M77,259.06A58.74,58.74,0,0,1,100.78,255a81.87,81.87,0,0,1,22.65,4.52c10.36,3.42,19.67,8.56,26,16.26,5.08,6.16,9.54,12.6,13.79,17.19,4.86,5.25,5.51,10.85,2.28,17.24s-10.35,13.66-19.09,20.57a146.35,146.35,0,0,1-16.65,11.52,105.79,105.79,0,0,1-19,8.84,83.81,83.81,0,0,1-24.19,4.38,74.37,74.37,0,0,1-23.77-3A65.06,65.06,0,0,1,42,342,62.28,62.28,0,0,1,21.46,314.6c-3.78-9.87-4.48-20.46-3.36-27.42,1.81-11.35,6.46-15.25,15.63-17.26,4.78-1,10.69-1.79,17.93-3.3A155.83,155.83,0,0,0,77,259.06Z"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    className: "cls-146",
    d: "M79.15,259.59a62.39,62.39,0,0,1,24.11-4.89,79.15,79.15,0,0,1,22.79,3.81c10.44,3.19,19.73,8.27,26,16,5,6.16,9.41,12.65,13.6,17.35,4.82,5.39,5.6,11,2.57,17.36s-9.88,13.54-18.41,20.43a144.66,144.66,0,0,1-16.49,11.65,110.35,110.35,0,0,1-19.08,9.14,88.51,88.51,0,0,1-24.62,4.94,78.28,78.28,0,0,1-24.25-2.21A65.77,65.77,0,0,1,44,343.46,60.29,60.29,0,0,1,22.81,317c-4-9.67-4.89-20.07-3.81-27.18,1.76-11.68,6.43-15.76,15.79-18,4.87-1.19,10.9-2.08,18.33-3.8a165.91,165.91,0,0,0,26-8.39Z"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    className: "cls-147",
    d: "M81.29,260a66.58,66.58,0,0,1,24.45-5.63,75.93,75.93,0,0,1,22.92,3.13c10.53,3,19.79,8,26,15.75,5,6.16,9.26,12.72,13.41,17.52,4.77,5.53,5.68,11.16,2.86,17.48s-9.39,13.4-17.7,20.26a142.83,142.83,0,0,1-16.33,11.76,114,114,0,0,1-19.16,9.44,93.19,93.19,0,0,1-25,5.47A83.26,83.26,0,0,1,68,353.77a66.25,66.25,0,0,1-21.86-8.91A58.43,58.43,0,0,1,24.2,319.38c-4.2-9.48-5.32-19.64-4.29-26.89,1.71-12,6.42-16.3,16-18.86,5-1.32,11.12-2.39,18.76-4.32A179.23,179.23,0,0,0,81.29,260Z"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    className: "cls-148",
    d: "M83.45,260.46a70.64,70.64,0,0,1,24.79-6.36,73.75,73.75,0,0,1,23,2.48c10.61,2.75,19.85,7.76,26,15.56,4.88,6.16,9.12,12.79,13.22,17.7,4.73,5.66,5.77,11.3,3.16,17.58s-8.89,13.26-17,20.08a138.79,138.79,0,0,1-16.15,11.87,117.45,117.45,0,0,1-19.23,9.7,98.47,98.47,0,0,1-25.43,6,89.85,89.85,0,0,1-25.26-.73,67.9,67.9,0,0,1-22.39-8.11,56.78,56.78,0,0,1-22.65-24.49c-4.42-9.26-5.77-19.16-4.78-26.55,1.65-12.36,6.4-16.82,16.14-19.68,5-1.48,11.35-2.72,19.19-4.89a192.52,192.52,0,0,0,27.3-10.16Z"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    className: "cls-149",
    d: "M85.66,260.73a74.69,74.69,0,0,1,25.13-7.06,71.3,71.3,0,0,1,23.15,1.87c10.69,2.54,19.88,7.55,26,15.4,4.81,6.17,9,12.86,13,17.87,4.69,5.8,5.86,11.45,3.47,17.68s-8.38,13.12-16.23,19.89a135,135,0,0,1-16,11.95,121.07,121.07,0,0,1-19.28,10,102.7,102.7,0,0,1-25.82,6.46,97.67,97.67,0,0,1-25.79,0,69.9,69.9,0,0,1-22.92-7.3A55.35,55.35,0,0,1,27,324c-4.64-9-6.24-18.63-5.3-26.15,1.6-12.71,6.39-17.37,16.33-20.53,5.15-1.64,11.59-3.06,19.65-5.49A207,207,0,0,0,85.66,260.73Z"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    className: "cls-150",
    d: "M87.83,261a79.73,79.73,0,0,1,25.45-7.75,69.89,69.89,0,0,1,23.25,1.29c10.77,2.36,19.93,7.37,26,15.28,4.75,6.19,8.83,12.94,12.84,18.06,4.65,5.93,6,11.59,3.78,17.77s-7.85,13-15.47,19.68a130.77,130.77,0,0,1-15.74,12,123.5,123.5,0,0,1-19.28,10.23,113.93,113.93,0,0,1-52.53,7.52,71.69,71.69,0,0,1-23.44-6.49,54,54,0,0,1-24.15-22.43c-4.87-8.81-6.74-18.05-5.84-25.7,1.54-13,6.37-17.9,16.53-21.39,5.25-1.8,11.84-3.42,20.12-6.11A229.84,229.84,0,0,0,87.83,261Z"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    className: "cls-151",
    d: "M90.05,261.16a84.27,84.27,0,0,1,25.77-8.4,68,68,0,0,1,23.34.74c10.84,2.18,20,7.22,26,15.19,4.68,6.21,8.69,13,12.65,18.26,4.6,6.06,6,11.72,4.1,17.84s-7.32,12.8-14.69,19.47a126.84,126.84,0,0,1-15.56,12.06,124.77,124.77,0,0,1-19.34,10.44,111,111,0,0,1-26.58,7.35,116.28,116.28,0,0,1-26.88,1.21,74.18,74.18,0,0,1-24-5.69,53.17,53.17,0,0,1-24.92-21.36c-5.1-8.56-7.25-17.42-6.39-25.19,1.47-13.37,6.39-18.46,16.74-22.27,5.33-2,12.08-3.81,20.6-6.78A253.2,253.2,0,0,0,90,261.16Z"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    className: "cls-152",
    d: "M92.29,261.28a88.93,88.93,0,0,1,26.07-9,66.82,66.82,0,0,1,23.43.22c10.91,2,20,7.1,25.94,15.15,4.61,6.23,8.55,13.12,12.46,18.44,4.56,6.19,6.15,11.85,4.43,17.92s-6.78,12.62-13.9,19.23a122.66,122.66,0,0,1-15.26,12.1A127.75,127.75,0,0,1,136.11,346a114.92,114.92,0,0,1-26.94,7.76,129.42,129.42,0,0,1-27.45,1.77,77.77,77.77,0,0,1-24.49-4.89c-11.79-4.56-20.35-11.95-25.69-20.27s-7.47-17.54-7-24.68c.89-12.39,6.36-19,17-23.13,5.45-2.14,12.35-4.2,21.11-7.46S81.55,266.84,92.29,261.28Z"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    className: "cls-153",
    d: "M94.55,261.34a94.36,94.36,0,0,1,26.37-9.63,66,66,0,0,1,23.5-.27c11,1.88,20,7,25.9,15.14,4.54,6.26,8.4,13.23,12.28,18.64,4.52,6.32,6.25,12,4.76,18s-6.23,12.45-13.09,19a117.18,117.18,0,0,1-15,12.13,128.39,128.39,0,0,1-19.35,10.85,117.56,117.56,0,0,1-27.28,8.14,143.62,143.62,0,0,1-28,2.28,81.71,81.71,0,0,1-25-4.09c-12-4.12-20.9-11.11-26.48-19.16s-7.91-17.15-7.53-24.18c.68-12.3,6.32-19.4,17.14-23.94,5.57-2.33,12.69-4.47,21.64-8.19S83.66,267.14,94.55,261.34Z"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    className: "cls-154",
    d: "M96.83,261.34a99.8,99.8,0,0,1,26.64-10.2,64.65,64.65,0,0,1,23.57-.72c11,1.75,20,7,25.86,15.17,4.48,6.29,8.26,13.32,12.09,18.84,4.48,6.44,6.36,12.09,5.11,18s-5.67,12.26-12.27,18.72a112.49,112.49,0,0,1-14.72,12.14,133.27,133.27,0,0,1-19.34,11,120.23,120.23,0,0,1-27.61,8.49,148.89,148.89,0,0,1-28.64,2.76A90.83,90.83,0,0,1,62,352.22c-12.29-3.67-21.45-10.26-27.28-18s-8.35-16.73-8.1-23.65c.46-12.21,6.26-19.81,17.33-24.73,5.68-2.53,13.06-4.94,22.16-9s19.59-9.5,30.71-15.54Z"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    className: "cls-155",
    d: "M99.11,261.3A105.46,105.46,0,0,1,126,250.55a63.88,63.88,0,0,1,23.62-1.09c11.11,1.63,20,6.92,25.8,15.23,4.41,6.33,8.12,13.43,11.91,19,4.44,6.56,6.46,12.2,5.45,18.08s-5.1,12.07-11.43,18.45A105.11,105.11,0,0,1,167,332.35a133.46,133.46,0,0,1-19.3,11.19,122.16,122.16,0,0,1-27.93,8.83,162.05,162.05,0,0,1-29.22,3.22,98.06,98.06,0,0,1-26-2.6c-12.53-3.23-22-9.4-28.09-16.9s-8.8-16.29-8.67-23.1c.23-12.11,6.17-20.2,17.51-25.52,5.81-2.73,13.42-5.44,22.68-9.81s19.91-10.1,31.21-16.36Z"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    className: "cls-156",
    d: "M101.42,261.2a110.54,110.54,0,0,1,27.24-11.26,62.73,62.73,0,0,1,23.67-1.53c11.18,1.52,20,6.93,25.75,15.33,4.35,6.37,8,13.54,11.73,19.23,4.39,6.67,6.57,12.3,5.8,18.11S191.09,313,185,319.25a100,100,0,0,1-14.12,12.11,132.58,132.58,0,0,1-19.25,11.37c-8.15,4-18.13,7-28.23,9.15a173.83,173.83,0,0,1-29.81,3.65,107.17,107.17,0,0,1-26.57-1.91c-12.77-2.79-22.56-8.54-28.9-15.75S28.88,322,28.88,315.34c0-12,6.1-20.55,17.71-26.3,5.93-2.93,13.77-6,23.18-10.65S90,267.68,101.49,261.2Z"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    className: "cls-157",
    d: "M103.73,261.06a116.25,116.25,0,0,1,27.45-11.75,62,62,0,0,1,23.71-1.89c11.24,1.44,20,7,25.69,15.47,4.28,6.41,7.85,13.65,11.55,19.42,4.35,6.78,6.68,12.39,6.15,18.13s-3.93,11.67-9.72,17.88a95.75,95.75,0,0,1-13.78,12.14A134,134,0,0,1,155.56,342c-8.18,4.06-18.27,7.21-28.52,9.44a187.22,187.22,0,0,1-30.38,4,118.49,118.49,0,0,1-27.13-1.25c-13-2.37-23.11-7.68-29.72-14.59s-9.74-15.38-9.87-22c-.23-11.89,6-20.87,17.89-27C53.9,287.41,62,284,71.52,279.05s20.57-11.3,32.21-18Z"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    className: "cls-158",
    d: "M106.06,260.88a121.8,121.8,0,0,1,27.69-12.21,61.1,61.1,0,0,1,23.75-2.22c11.29,1.36,20,7,25.61,15.65,4.22,6.46,7.72,13.76,11.37,19.6,4.31,6.89,6.8,12.48,6.52,18.14s-3.34,11.48-8.84,17.62a89,89,0,0,1-13.44,12,134.57,134.57,0,0,1-19.15,11.65c-8.2,4.15-18.4,7.39-28.8,9.72a201.88,201.88,0,0,1-30.94,4.4,133.61,133.61,0,0,1-27.7-.64c-13.24-1.95-23.66-6.83-30.54-13.43s-10.22-14.89-10.48-21.33C30.63,308.05,37,298.66,49.19,292c6.2-3.38,14.47-7.12,24.18-12.41s20.87-11.87,32.69-18.74Z"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    className: "cls-159",
    d: "M108.39,260.66A126.61,126.61,0,0,1,136.32,248a60.15,60.15,0,0,1,23.77-2.51,34,34,0,0,1,25.57,15.85c4.15,6.51,7.57,13.87,11.19,19.79,4.26,7,6.9,12.55,6.88,18.14s-2.74,11.26-8,17.27a82.74,82.74,0,0,1-13.09,12,134,134,0,0,1-19.07,11.77c-8.2,4.23-18.5,7.55-29,10a213.42,213.42,0,0,1-31.5,4.72A150,150,0,0,1,74.8,355c-13.47-1.53-24.22-6-31.37-12.25S32.72,328.33,32.33,322c-.72-11.64,5.79-21.43,18.27-28.54,6.34-3.61,14.8-7.73,24.66-13.3s21.18-12.44,33.15-19.49Z"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    className: "cls-160",
    d: "M110.73,260.4a133.41,133.41,0,0,1,28.16-13c8.75-2.68,16.7-3.54,23.79-2.77a33.37,33.37,0,0,1,25.47,16.11c4.09,6.56,7.44,14,11,20,4.22,7.07,7,12.62,7.26,18.12s-2.14,11.05-7.06,17a76.34,76.34,0,0,1-12.69,11.81,133.44,133.44,0,0,1-19,11.89c-8.21,4.3-18.61,7.7-29.3,10.2a229.21,229.21,0,0,1-32,5,174,174,0,0,1-28.87.46c-13.69-1.13-24.77-5.12-32.19-11.09s-11.21-13.87-11.73-20.06a29,29,0,0,1,4.5-17.17c3.07-4.75,7.55-8.29,14-12.09s15.13-8.35,25.12-14.21,21.48-13,33.61-20.21Z"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    className: "cls-161",
    d: "M113.08,260.12c10-6,19.59-10.62,28.38-13.41s16.75-3.75,23.8-3c11.45,1.22,19.91,7.41,25.38,16.39,4,6.62,7.3,14.08,10.83,20.13,4.18,7.16,7.14,12.67,7.63,18.1S207.58,309.16,203,315a72.29,72.29,0,0,1-12.3,11.86,133.06,133.06,0,0,1-18.86,12c-8.22,4.38-18.72,7.85-29.55,10.42a240.89,240.89,0,0,1-32.59,5.22,200,200,0,0,1-29.47.93c-13.91-.73-25.31-4.27-33-9.91s-11.72-13.34-12.37-19.39c-.62-5.68,1.25-12.39,4.38-17.29s7.7-8.63,14.25-12.68S68.89,287.12,79,281s21.78-13.52,34.06-20.9Z"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    className: "cls-162",
    d: "M115.44,259.79c10.07-6.1,19.75-10.85,28.58-13.74s16.8-3.92,23.8-3.19c11.5,1.2,19.88,7.59,25.3,16.71,4,6.67,7.16,14.18,10.65,20.28,4.14,7.24,7.25,12.72,8,18.06s-.9,10.61-5.23,16.31A65.53,65.53,0,0,1,194.66,326a132.25,132.25,0,0,1-18.74,12.06c-8.22,4.45-18.8,8-29.76,10.62a254.1,254.1,0,0,1-33,5.49,237.94,237.94,0,0,1-30.08,1.36c-14.13-.36-25.86-3.45-33.84-8.75S37,334,36.24,328.06c-.75-5.6,1.08-12.32,4.25-17.38s7.85-9,14.57-13.29,15.72-9.61,26-16S103,267.32,115.44,259.79Z"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    className: "cls-163",
    d: "M117.8,259.46c10.16-6.19,19.92-11.06,28.78-14s16.84-4.08,23.79-3.36c11.55,1.21,19.85,7.82,25.21,17.07,3.9,6.74,7,14.29,10.47,20.44,4.09,7.3,7.37,12.75,8.38,18s-.28,10.39-4.3,16a60.2,60.2,0,0,1-11.47,11.58,130.82,130.82,0,0,1-18.6,12.14c-8.2,4.51-18.86,8.11-30,10.8a262.7,262.7,0,0,1-33.54,5.67,271.91,271.91,0,0,1-30.72,1.74c-14.35-.07-26.39-2.63-34.66-7.59s-12.75-12.23-13.67-18c-.88-5.51.88-12.22,4.11-17.45s8-9.33,14.89-13.91C61.11,295.5,66.72,292,73,288q10.41-6.64,20.78-13.34c7.55-4.86,15.67-10.09,24-15.2Z"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    className: "cls-164",
    d: "M120.16,259.07c10.25-6.28,20.07-11.25,29-14.32s16.87-4.21,23.78-3.48c11.59,1.21,19.8,8.07,25.11,17.46,3.84,6.79,6.88,14.38,10.29,20.57,4,7.36,7.49,12.77,8.76,17.94s.34,10.16-3.37,15.64a55.27,55.27,0,0,1-11.07,11.58,130.1,130.1,0,0,1-18.45,12.21c-8.19,4.56-18.92,8.22-30.12,11a273.83,273.83,0,0,1-34,5.83,309.94,309.94,0,0,1-31.34,2.08c-14.63.18-26.94-1.85-35.49-6.47S40,337.46,38.93,331.81c-1-5.43.68-12.11,4-17.5s8.16-9.7,15.23-14.55c4.74-3.27,10.42-7,16.75-11.2s13.4-8.85,21-13.86S111.66,264.26,120.16,259.07Z"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    className: "cls-165",
    d: "M122.53,258.67c10.33-6.35,20.22-11.42,29.15-14.55s16.89-4.32,23.76-3.58c11.63,1.25,19.75,8.35,25,17.89,3.79,6.86,6.73,14.48,10.1,20.7,8,14.82,13.52,22.43,6.72,33.15a50.08,50.08,0,0,1-10.6,11.43A127.56,127.56,0,0,1,188.36,336c-8.16,4.63-19,8.34-30.27,11.11a281.68,281.68,0,0,1-34.49,6c-11.32,1.31-22.15,2.11-32,2.37-14.91.41-27.49-1.11-36.33-5.38S41.46,339,40.27,333.5c-1.16-5.34.47-12,3.81-17.52s8.32-10.07,15.57-15.21q8.43-6,17-11.8c6.41-4.36,13.57-9.2,21.3-14.36S114,264,122.54,258.7Z"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    className: "cls-166",
    d: "M125.23,257.85c10.42-6.43,20.37-11.59,29.33-14.77s16.91-4.39,23.72-3.61c11.66,1.32,19.66,8.74,24.85,18.47,3.71,7,6.52,14.63,9.81,20.89,7.86,15,14.14,22.26,8,32.74a45.12,45.12,0,0,1-10.14,11.29,126,126,0,0,1-18.07,12.31c-8.13,4.67-19,8.44-30.39,11.26a290.13,290.13,0,0,1-35,6.11c-11.52,1.38-22.58,2.28-32.63,2.7-15.2.64-28.09-.34-37.22-4.25s-14.34-10.47-15.66-15.86.29-11.89,3.69-17.63,8.57-10.31,16-16c5-3.82,10.72-7.91,17.22-12.47s13.75-9.6,21.58-14.92S116.59,263.18,125.23,257.85Z"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    className: "cls-167",
    d: "M127.49,257.56C138,251.08,148,245.86,157,242.63s16.93-4.45,23.69-3.66c11.69,1.38,19.6,9.08,24.76,18.94,3.66,7,6.39,14.7,9.66,21,7.8,15,14.86,22,9.35,32.25-1.88,3.49-5.07,7.21-9.68,11.16a124.55,124.55,0,0,1-17.9,12.34c-8.1,4.72-19,8.52-30.51,11.36A300.7,300.7,0,0,1,131,352.19c-11.7,1.4-23,2.36-33.21,2.89-15.47.81-28.65.29-38.07-3.26S44.8,342,43.33,336.73s0-11.68,3.5-17.58,8.81-10.75,16.32-16.69c5-4,10.83-8.24,17.4-13s13.91-9.91,21.82-15.36,16.39-11.17,25.12-16.55Z"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    className: "cls-168",
    d: "M129.73,257.26c10.57-6.51,20.63-11.8,29.63-15.06s16.94-4.5,23.65-3.67C194.75,240,202.57,248,207.68,258c3.61,7.06,6.28,14.75,9.51,21,7.73,15,15.59,21.76,10.7,31.76-1.67,3.42-4.71,7.08-9.21,11A122,122,0,0,1,201,334.1c-8.07,4.76-19,8.6-30.63,11.46a298.82,298.82,0,0,1-35.77,6.19q-16.83,2-33.75,3c-15.74,1-29.23.88-38.94-2.32s-15.44-9.22-17-14.3-.21-11.44,3.3-17.51,9-11.21,16.62-17.39c5.07-4.13,10.94-8.55,17.59-13.43q10.92-8,22-15.79c8-5.58,16.56-11.38,25.36-16.81Z"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    className: "cls-169",
    d: "M219.28,279.17c6.48,12.65,13.84,19,13.22,26.79s-9.73,17.09-27.43,27.69c-8,4.81-19,8.68-30.7,11.54a300.79,300.79,0,0,1-36.14,6.18c-12,1.43-23.67,2.44-34.33,3.16-16,1.09-29.78,1.42-39.79-1.42s-16-8.58-17.76-13.51-.48-11.19,3.09-17.41,9.26-11.67,16.92-18.09c5.11-4.28,11-8.87,17.76-13.9q11-8.25,22.27-16.21c8.07-5.69,16.72-11.58,25.59-17,17.75-10.91,33.88-18.15,46.36-19s21.34,4.62,27.41,13.13S215,270.73,219.28,279.17Z"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    className: "cls-170",
    d: "M126,264.08c13.45-8.11,26.15-14.5,37-17.53s19.85-2.7,26.91.56c6.79,3.14,11.83,8.87,15.64,15.48S213,276.14,216.73,282c6.58,10.3,13.36,16.45,14.34,23.17.54,3.72-.67,7.57-4.1,11.84-4.72,5.9-13.9,12.68-26.45,19.79-8.78,5-20.43,8.86-32.52,11.54a278.39,278.39,0,0,1-36.7,5.25q-16.94,1.41-33.94,1.83c-14.64.37-27.38-.14-36.69-3.22s-15-8.48-16.92-12.83-1.33-9.42,2-15.28,8.49-10.48,15.94-16.23,16.76-12.21,27.68-19.73S112.85,272,126,264.08Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-171"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-172",
    points: "1332.07 123.47 1442.88 123.47 1347.12 -48.58 1499.66 -216.53 1388.85 -216.53 1305.39 -124.73 1254.09 -216.53 1143.28 -216.53 1236.3 -48.58 1079.66 123.47 1190.47 123.47 1278.71 26.91 1332.07 123.47"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAmiriyaHeroAr);
export default __webpack_public_path__ + "static/media/amiriyaHeroAr.78b790fd465ed2f6181ab17f09dc209c.svg";
export { ForwardRef as ReactComponent };